import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';
import { Badge } from '../../ui/badge';
import {
  Plus,
  Edit,
  Trash2,
  Save,
  X,
  Menu as MenuIcon,
  ChevronDown,
  ChevronRight,
  ArrowUp,
  ArrowDown,
  Eye,
  EyeOff,
  Link as LinkIcon,
  Layout,
  FileText,
  Globe,
  Server,
  Cpu,
  Database,
  Mail,
  Lock,
  Shield,
  ShieldCheck,
  BadgeCheck,
  MonitorSmartphone,
  Palette,
  ShoppingCart,
  Layers,
  Search,
  Target,
  Rocket,
  Megaphone,
  Users,
  BookOpen,
  GraduationCap,
  Tag,
  RefreshCw,
  Home,
  Phone,
  MapPin,
  Settings,
  Star,
  Crown,
  Zap,
  Image as ImageIcon,
  HelpCircle,
  Info,
  AlertCircle,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Bell,
  Calendar,
  Clock,
  Cloud,
  Copy,
  Download,
  Upload,
  ExternalLink,
  Heart,
  Gift,
  Briefcase,
  Package,
  Truck,
  CreditCard,
  DollarSign,
  BarChart,
  TrendingUp,
  Award,
  Bookmark,
  Flag,
  Code,
  Terminal,
  Grid,
  List,
  Filter,
  Share2,
  Send,
  Paperclip,
  MessageCircle,
  MessageSquare,
  Video,
  Mic,
  Camera,
  Folder,
  File,
  Lightbulb,
  Key,
  Wifi,
  Activity,
  Repeat,
  Bot
} from 'lucide-react';
import { API_URLS } from '../../../config/api';
import { adminApiFetch } from '../../../utils/adminApi';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '../../ui/command';

const AdminMenus = () => {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingMenu, setEditingMenu] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState(new Set());
  const [filterType, setFilterType] = useState('all'); // 'all', 'navbar', 'footer'
  const [footerSettings, setFooterSettings] = useState({
    logo_url: '',
    navbar_logo_url: '',
    company_name: '',
    description: '',
    copyright_text: '',
    newsletter_text: '',
    copyright_links: [
      { title: 'Gizlilik Politikası', url: '/privacy' },
      { title: 'Kullanım Şartları', url: '/terms' },
      { title: 'Çerez Politikası', url: '/cookies' }
    ]
  });
  const [footerSettingsLoading, setFooterSettingsLoading] = useState(false);
  const [logoError, setLogoError] = useState(false);
  
  // Hosting Tabs Editor
  const [showHostingTabsEditor, setShowHostingTabsEditor] = useState(false);
  const [editingHostingTabs, setEditingHostingTabs] = useState(null);
  const [editingHostingMenuId, setEditingHostingMenuId] = useState(null);
  const [editingHostingRight, setEditingHostingRight] = useState(null);
  
  // Generic Tabs Editor (herhangi bir mega menu için)
  const [showTabsEditor, setShowTabsEditor] = useState(false);
  const [editingTabs, setEditingTabs] = useState(null);
  const [editingTabsMenuId, setEditingTabsMenuId] = useState(null);
  const [expandedTabs, setExpandedTabs] = useState(new Set()); // Açık sekmeler için state
  const [expandedHostingTabs, setExpandedHostingTabs] = useState(new Set()); // Hosting sekmeleri için state
  
  // Media Library
  const [showMediaLibrary, setShowMediaLibrary] = useState(false);
  const [mediaFiles, setMediaFiles] = useState([]);
  const [loadingMedia, setLoadingMedia] = useState(false);
  const [selectedImageField, setSelectedImageField] = useState(null);
  
  // URL Dropdown
  const [availableUrls, setAvailableUrls] = useState([]);
  const [loadingUrls, setLoadingUrls] = useState(false);
  const [urlDropdownOpen, setUrlDropdownOpen] = useState(false);

  // Menu key seçenekleri
  const MENU_KEY_OPTIONS = {
    navbar: [
      { value: 'domain', label: 'Domain Mega Menü' },
      { value: 'website', label: 'Web Sitesi Mega Menü' },
      { value: 'hosting', label: 'Hosting Mega Menü' },
      { value: 'server', label: 'Sunucu Mega Menü' },
      { value: 'ssl', label: 'SSL Mega Menü' },
      { value: 'marketing', label: 'Pazarlama / Hizmetler' },
      { value: 'marka', label: 'Marka' },
      { value: 'knowledge-base', label: 'Bilgi Bankası' },
      { value: 'iletisim', label: 'İletişim' },
      { value: 'ai_chatbot', label: 'AI Chatbot' }
    ],
    footer: [
      { value: 'footer_services', label: '2. Sütun - Hizmetlerimiz' },
      { value: 'footer_corporate', label: '3. Sütun - Kurumsal' },
      { value: 'footer_social', label: '4. Sütun - Sosyal / Bülten' }
    ]
  };

  // İkon seçenekleri
  const iconOptions = [
    // Temel İkonlar
    { name: 'Home', component: Home },
    { name: 'Menu', component: MenuIcon },
    { name: 'Settings', component: Settings },
    { name: 'Search', component: Search },
    { name: 'Star', component: Star },
    
    // Bilgi & Yardım
    { name: 'HelpCircle', component: HelpCircle },
    { name: 'Info', component: Info },
    { name: 'AlertCircle', component: AlertCircle },
    { name: 'AlertTriangle', component: AlertTriangle },
    { name: 'CheckCircle', component: CheckCircle },
    { name: 'XCircle', component: XCircle },
    
    // Teknoloji & Hosting
    { name: 'Globe', component: Globe },
    { name: 'Server', component: Server },
    { name: 'Cpu', component: Cpu },
    { name: 'Database', component: Database },
    { name: 'Cloud', component: Cloud },
    { name: 'Wifi', component: Wifi },
    { name: 'Activity', component: Activity },
    { name: 'Terminal', component: Terminal },
    { name: 'Code', component: Code },
    
    // Güvenlik
    { name: 'Lock', component: Lock },
    { name: 'Shield', component: Shield },
    { name: 'ShieldCheck', component: ShieldCheck },
    { name: 'Key', component: Key },
    { name: 'BadgeCheck', component: BadgeCheck },
    
    // İletişim
    { name: 'Mail', component: Mail },
    { name: 'Phone', component: Phone },
    { name: 'MessageCircle', component: MessageCircle },
    { name: 'MessageSquare', component: MessageSquare },
    { name: 'Send', component: Send },
    { name: 'Bell', component: Bell },
    { name: 'Bot', component: Bot },
    
    // E-ticaret & Finans
    { name: 'ShoppingCart', component: ShoppingCart },
    { name: 'Package', component: Package },
    { name: 'Truck', component: Truck },
    { name: 'CreditCard', component: CreditCard },
    { name: 'DollarSign', component: DollarSign },
    { name: 'Gift', component: Gift },
    
    // Tasarım & Medya
    { name: 'MonitorSmartphone', component: MonitorSmartphone },
    { name: 'Palette', component: Palette },
    { name: 'Image', component: ImageIcon },
    { name: 'Camera', component: Camera },
    { name: 'Video', component: Video },
    { name: 'Mic', component: Mic },
    { name: 'Lightbulb', component: Lightbulb },
    
    // İçerik & Belgeler
    { name: 'FileText', component: FileText },
    { name: 'BookOpen', component: BookOpen },
    { name: 'File', component: File },
    { name: 'Folder', component: Folder },
    { name: 'Copy', component: Copy },
    { name: 'Paperclip', component: Paperclip },
    
    // İş & Organizasyon
    { name: 'Briefcase', component: Briefcase },
    { name: 'Users', component: Users },
    { name: 'Calendar', component: Calendar },
    { name: 'Clock', component: Clock },
    { name: 'Tag', component: Tag },
    { name: 'Bookmark', component: Bookmark },
    { name: 'Flag', component: Flag },
    
    // Eğitim & Büyüme
    { name: 'GraduationCap', component: GraduationCap },
    { name: 'Target', component: Target },
    { name: 'Rocket', component: Rocket },
    { name: 'TrendingUp', component: TrendingUp },
    { name: 'BarChart', component: BarChart },
    { name: 'Award', component: Award },
    { name: 'Crown', component: Crown },
    
    // Pazarlama & Sosyal
    { name: 'Megaphone', component: Megaphone },
    { name: 'Share2', component: Share2 },
    { name: 'Heart', component: Heart },
    { name: 'Zap', component: Zap },
    
    // Navigasyon & Aksiyon
    { name: 'ChevronDown', component: ChevronDown },
    { name: 'ChevronRight', component: ChevronRight },
    { name: 'ExternalLink', component: ExternalLink },
    { name: 'Download', component: Download },
    { name: 'Upload', component: Upload },
    { name: 'RefreshCw', component: RefreshCw },
    { name: 'Repeat', component: Repeat },
    
    // Görünüm & Düzen
    { name: 'MapPin', component: MapPin },
    { name: 'Layers', component: Layers },
    { name: 'Layout', component: Layout },
    { name: 'Grid', component: Grid },
    { name: 'List', component: List },
    { name: 'Filter', component: Filter }
  ];

  // Seçili ikonun componentini al
  const getIconComponent = (iconName) => {
    const icon = iconOptions.find(i => i.name === iconName);
    return icon ? icon.component : MenuIcon;
  };

  // Navbar renk seçenekleri
  const navbarColorOptions = {
    text: [
      { value: 'text-gray-700', label: 'Gri', preview: '#374151' },
      { value: 'text-white', label: 'Beyaz', preview: '#ffffff' },
      { value: 'text-gray-900', label: 'Siyah', preview: '#111827' },
      { value: 'text-purple-600', label: 'Mor', preview: '#9333ea' },
      { value: 'text-blue-600', label: 'Mavi', preview: '#2563eb' },
      { value: 'text-indigo-600', label: 'İndigo', preview: '#4f46e5' },
      { value: 'text-emerald-600', label: 'Yeşil', preview: '#059669' },
      { value: 'text-green-600', label: 'Açık Yeşil', preview: '#16a34a' },
      { value: 'text-rose-600', label: 'Kırmızı', preview: '#e11d48' },
      { value: 'text-pink-600', label: 'Pembe', preview: '#db2777' },
      { value: 'text-orange-600', label: 'Turuncu', preview: '#ea580c' },
      { value: 'text-amber-600', label: 'Amber', preview: '#d97706' },
      { value: 'text-yellow-600', label: 'Sarı', preview: '#ca8a04' },
      { value: 'text-cyan-600', label: 'Turkuaz', preview: '#0891b2' },
      { value: 'text-teal-600', label: 'Deniz Yeşili', preview: '#0d9488' }
    ],
    hover: [
      { value: 'hover:text-white', label: 'Beyaz', preview: '#ffffff' },
      { value: 'hover:text-gray-900', label: 'Siyah', preview: '#111827' },
      { value: 'hover:text-purple-600', label: 'Mor', preview: '#9333ea' },
      { value: 'hover:text-blue-600', label: 'Mavi', preview: '#2563eb' },
      { value: 'hover:text-indigo-600', label: 'İndigo', preview: '#4f46e5' },
      { value: 'hover:text-emerald-600', label: 'Yeşil', preview: '#059669' },
      { value: 'hover:text-green-600', label: 'Açık Yeşil', preview: '#16a34a' },
      { value: 'hover:text-rose-600', label: 'Kırmızı', preview: '#e11d48' },
      { value: 'hover:text-pink-600', label: 'Pembe', preview: '#db2777' },
      { value: 'hover:text-orange-600', label: 'Turuncu', preview: '#ea580c' },
      { value: 'hover:text-amber-600', label: 'Amber', preview: '#d97706' },
      { value: 'hover:text-yellow-600', label: 'Sarı', preview: '#ca8a04' },
      { value: 'hover:text-cyan-600', label: 'Turkuaz', preview: '#0891b2' },
      { value: 'hover:text-teal-600', label: 'Deniz Yeşili', preview: '#0d9488' }
    ],
    bg: [
      { value: '', label: 'Yok', preview: 'transparent' },
      // Soluk arka planlar
      { value: 'bg-gray-50', label: 'Gri (Soluk)', preview: '#f9fafb' },
      { value: 'bg-purple-50', label: 'Mor (Soluk)', preview: '#faf5ff' },
      { value: 'bg-blue-50', label: 'Mavi (Soluk)', preview: '#eff6ff' },
      { value: 'bg-indigo-50', label: 'İndigo (Soluk)', preview: '#eef2ff' },
      { value: 'bg-green-50', label: 'Yeşil (Soluk)', preview: '#f0fdf4' },
      { value: 'bg-rose-50', label: 'Kırmızı (Soluk)', preview: '#fff1f2' },
      // Canlı arka planlar
      { value: 'bg-black', label: 'Siyah (Canlı)', preview: '#000000' },
      { value: 'bg-purple-600', label: 'Mor (Canlı)', preview: '#7c3aed' },
      { value: 'bg-blue-600', label: 'Mavi (Canlı)', preview: '#2563eb' },
      { value: 'bg-emerald-600', label: 'Yeşil (Canlı)', preview: '#059669' },
      { value: 'bg-rose-600', label: 'Kırmızı (Canlı)', preview: '#e11d48' },
      // Gradient örneği
      { value: 'bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-700', label: 'Gradient (AI)', preview: 'linear-gradient(to right, #fbbf24, #ec4899, #7e22ce)' }
    ],
    hoverBg: [
      { value: '', label: 'Yok', preview: 'transparent' },
      { value: 'hover:bg-purple-600', label: 'Mor', preview: '#9333ea' },
      { value: 'hover:bg-blue-600', label: 'Mavi', preview: '#2563eb' },
      { value: 'hover:bg-indigo-600', label: 'İndigo', preview: '#4f46e5' },
      { value: 'hover:bg-emerald-600', label: 'Yeşil', preview: '#059669' },
      { value: 'hover:bg-green-600', label: 'Açık Yeşil', preview: '#16a34a' },
      { value: 'hover:bg-rose-600', label: 'Kırmızı', preview: '#e11d48' },
      { value: 'hover:bg-pink-600', label: 'Pembe', preview: '#db2777' },
      { value: 'hover:bg-orange-600', label: 'Turuncu', preview: '#ea580c' },
      { value: 'hover:bg-amber-600', label: 'Amber', preview: '#d97706' },
      { value: 'hover:bg-yellow-600', label: 'Sarı', preview: '#ca8a04' },
      { value: 'hover:bg-cyan-600', label: 'Turkuaz', preview: '#0891b2' },
      { value: 'hover:bg-teal-600', label: 'Deniz Yeşili', preview: '#0d9488' }
    ]
  };
  
  // Ana menünün formatını bul (alt menüler için)
  const getParentMenuFormat = (parentId) => {
    if (!parentId) return null;
    const parentMenu = menus.find(m => m.id === parentId);
    return parentMenu ? parentMenu.is_list_format : null;
  };
  const [formData, setFormData] = useState({
    title: '',
    url: '',
    description: '',
    icon: '',
    target: '_self',
    type: 'navbar',
    menu_key: '',
    parent_id: null,
    order_index: 0,
    is_mega_menu: false,
    mega_menu_column: null,
    mega_menu_section: null,
    is_promo_card: false,
    promo_data: null,
    is_list_format: false,
    is_header: false,
    is_special: false,
    is_active: true,
    text_color: '',
    hover_color: '',
    bg_color: '',
    hover_bg_color: '',
    icon_color: '',
    footer_column: null,
    hosting_tabs: null, // Özel sekme yapısı (hosting_tabs alanı genel kullanım için)
    has_custom_tabs: false // Özel sekme yapısı var mı?
  });

  const apiBase = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '';

  useEffect(() => {
    fetchMenus();
    fetchFooterSettings();
    fetchAvailableUrls();
  }, []);

  const fetchAvailableUrls = async () => {
    try {
      setLoadingUrls(true);
      const response = await adminApiFetch(`${apiBase}/backend/admin_api.php?action=getMenuUrls`);
      const result = await response.json();
      
      if (result.status === 'success') {
        setAvailableUrls(result.data || []);
      }
    } catch (error) {
      console.error('fetchAvailableUrls hatası:', error);
    } finally {
      setLoadingUrls(false);
    }
  };

  const fetchFooterSettings = async () => {
    try {
      const response = await adminApiFetch(`${apiBase}/backend/admin_api.php?action=getFooterSettings`);
      const result = await response.json();
      if (result.status === 'success' && result.data) {
        const data = result.data;
        // Ensure copyright_links is an array
        if (data.copyright_links) {
          if (typeof data.copyright_links === 'string') {
            try {
              data.copyright_links = JSON.parse(data.copyright_links);
            } catch (e) {
              data.copyright_links = [];
            }
          }
        } else {
          data.copyright_links = [
            { title: 'Gizlilik Politikası', url: '/privacy' },
            { title: 'Kullanım Şartları', url: '/terms' },
            { title: 'Çerez Politikası', url: '/cookies' }
          ];
        }
        setFooterSettings(data);
      }
    } catch (error) {
      console.error('Footer ayarları yüklenemedi:', error);
    }
  };

  const handleSaveFooterSettings = async () => {
    try {
      setFooterSettingsLoading(true);
      const response = await adminApiFetch(
        `${apiBase}/backend/admin_api.php?action=updateFooterSettings`,
        {
          method: 'POST',
          body: JSON.stringify(footerSettings)
        }
      );
      const result = await response.json();
      
      if (result.status === 'success') {
        alert('Footer ayarları başarıyla kaydedildi!');
      } else {
        alert('Hata: ' + response.data.message);
      }
    } catch (error) {
      alert('Footer ayarları kaydedilemedi: ' + error.message);
    } finally {
      setFooterSettingsLoading(false);
    }
  };

  // Media Library Functions
  const openMediaLibrary = async (fieldName) => {
    setSelectedImageField(fieldName);
    setShowMediaLibrary(true);
    setLoadingMedia(true);
    
    try {
      const response = await fetch(`${apiBase}/backend/admin_api.php?action=getMedia`, {
        headers: {
          'Accept': 'application/json'
        },
        credentials: 'include'
      });
      
      if (!response.ok) {
        console.error('Media API error status:', response.status);
        setMediaFiles([]);
        return;
      }
      
      // First get text to check if response is valid JSON
      const responseText = await response.text();
      
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (parseError) {
        console.error('Error parsing media JSON:', parseError, 'Raw:', responseText.slice(0, 300));
        setMediaFiles([]);
        return;
      }
      
      if (result.status === 'success') {
        // Backend returns { status: 'success', data: [...] }
        setMediaFiles(result.data || []);
      } else {
        setMediaFiles([]);
      }
    } catch (error) {
      console.error('Medya dosyaları yüklenemedi:', error);
      setMediaFiles([]);
    } finally {
      setLoadingMedia(false);
    }
  };

  const handleSelectMedia = (file) => {
    if (selectedImageField === 'footer_logo') {
      setFooterSettings({ ...footerSettings, logo_url: file.url });
      setLogoError(false); // Reset error when new media is selected
    } else if (selectedImageField === 'navbar_logo') {
      setFooterSettings({ ...footerSettings, navbar_logo_url: file.url });
    }
    setShowMediaLibrary(false);
    setSelectedImageField(null);
  };

  const fetchMenus = async () => {
    try {
      console.log('fetchMenus başlatıldı...');
      setLoading(true);
      const response = await adminApiFetch(`${apiBase}/backend/admin_api.php?action=getMenus`);
      const result = await response.json();
      console.log('fetchMenus response:', result);
      
      if (result.status === 'success') {
        const menusData = result.data || [];
        console.log('Toplam menü sayısı:', menusData.length);
        
        // Menüleri order_index'e göre sırala
        const sortedMenus = menusData.sort((a, b) => {
          // Önce parent_id'ye göre (NULL olanlar önce)
          if (a.parent_id === null && b.parent_id !== null) return -1;
          if (a.parent_id !== null && b.parent_id === null) return 1;
          // Aynı parent_id'ye sahipse order_index'e göre
          if (a.parent_id === b.parent_id) {
            if (a.order_index !== b.order_index) {
              return a.order_index - b.order_index;
            }
            // Aynı order_index ise id'ye göre
            return a.id - b.id;
          }
          return 0;
        });
        setMenus(sortedMenus);
        console.log('Menüler state\'e yazıldı:', sortedMenus.length);
      }
      } catch (error) {
        console.error('fetchMenus hatası:', error);
      } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    // Mevcut filtreye göre otomatik tip ata
    const defaultType = filterType === 'footer' ? 'footer' : 'navbar';
    
    setFormData({
      title: '',
      url: '',
      description: '',
      icon: '',
      target: '_self',
      type: defaultType, // Filtreye göre otomatik
      menu_key: '',
      parent_id: null,
      order_index: 0,
      is_mega_menu: false,
      mega_menu_column: null,
      mega_menu_section: null,
      is_promo_card: false,
      promo_data: null,
      is_list_format: false,
      is_special: false,
      is_active: true,
      text_color: '',
      hover_color: '',
      bg_color: '',
      hover_bg_color: '',
      icon_color: '',
      footer_column: filterType === 'footer' ? 2 : null, // Footer ise default column 2
      hosting_tabs: null,
      has_custom_tabs: false
    });
    setEditingMenu(null);
    setShowForm(true);
    console.log('Yeni menü formu açıldı, tip:', defaultType);
  };

  const handleEdit = (menu) => {
    setFormData({
      ...menu,
      mega_menu_column: menu.mega_menu_column || null,
      mega_menu_section: menu.mega_menu_section || null,
      is_header: menu.is_header || false,
      promo_data: menu.promo_data ? (typeof menu.promo_data === 'string' ? JSON.parse(menu.promo_data) : menu.promo_data) : null,
      // Renk alanlarını da ekle (null ise boş string yap)
      text_color: menu.text_color || '',
      hover_color: menu.hover_color || '',
      bg_color: menu.bg_color || '',
      hover_bg_color: menu.hover_bg_color || '',
      icon_color: menu.icon_color || '',
      footer_column: menu.footer_column || null,
      hosting_tabs: menu.hosting_tabs ? (typeof menu.hosting_tabs === 'string' ? JSON.parse(menu.hosting_tabs) : menu.hosting_tabs) : null,
      has_custom_tabs: menu.has_tabs || !!menu.hosting_tabs // has_tabs alanını da kontrol et
    });
    setEditingMenu(menu.id);
    setShowForm(true);
  };

  const handleCreateFooterItem = (column) => {
    // Yeni footer menü öğesi oluştur
    setFormData({
      title: '',
      url: '',
      description: '',
      icon: '',
      target: '_self',
      type: 'footer',
      menu_key: '',
      parent_id: null,
      order_index: 0,
      is_mega_menu: false,
      mega_menu_column: null,
      mega_menu_section: null,
      is_promo_card: false,
      promo_data: null,
      is_list_format: false,
      is_header: false,
      is_special: false,
      is_active: true,
      text_color: '',
      hover_color: '',
      bg_color: '',
      hover_bg_color: '',
      icon_color: '',
      footer_column: column
    });
    setEditingMenu(null);
    setShowForm(true);
    setFilterType('footer');
  };

  const handleSave = async () => {
    try {
      console.log('handleSave başlatıldı, formData:', formData);
      
      const dataToSend = {
        ...formData,
        promo_data: formData.promo_data ? JSON.stringify(formData.promo_data) : null,
        hosting_tabs: formData.hosting_tabs ? JSON.stringify(formData.hosting_tabs) : null,
        is_mega_menu: formData.is_mega_menu ? 1 : 0,
        is_promo_card: formData.is_promo_card ? 1 : 0,
        is_list_format: formData.is_list_format ? 1 : 0,
        is_header: formData.is_header ? 1 : 0,
        is_special: formData.is_special ? 1 : 0,
        is_active: formData.is_active ? 1 : 0,
        has_tabs: (formData.has_custom_tabs || formData.hosting_tabs) ? 1 : 0, // has_tabs alanını ekle
        // Renk alanlarını temizle (boş string ise null gönder)
        text_color: formData.text_color || null,
        hover_color: formData.hover_color || null,
        bg_color: formData.bg_color || null,
        hover_bg_color: formData.hover_bg_color || null,
        icon_color: formData.icon_color || null
      };

      console.log('Gönderilecek data:', dataToSend);
      console.log('Editing menu:', editingMenu);

      if (editingMenu) {
        console.log('Update isteği gönderiliyor...');
        const response = await adminApiFetch(`${apiBase}/backend/admin_api.php?action=updateMenu`, {
          method: 'POST',
          body: JSON.stringify({
            id: editingMenu,
            ...dataToSend
          })
        });
        const updateResult = await response.json();
        console.log('Update response:', updateResult);
      } else {
        console.log('Create isteği gönderiliyor...');
        const response = await adminApiFetch(`${apiBase}/backend/admin_api.php?action=createMenu`, {
          method: 'POST',
          body: JSON.stringify(dataToSend)
        });
        const createResult = await response.json();
        console.log('Create response:', createResult);
      }

      await fetchMenus();
      
      // Eklenen/güncellenen menünün tipine göre filtreyi ayarla
      if (dataToSend.type === 'navbar' && filterType === 'footer') {
        setFilterType('navbar');
        console.log('Filtre navbar\'a değiştirildi');
      } else if (dataToSend.type === 'footer' && filterType === 'navbar') {
        setFilterType('footer');
        console.log('Filtre footer\'a değiştirildi');
      }
      
      setShowForm(false);
      setEditingMenu(null);
      alert('Menü başarıyla kaydedildi!');
    } catch (error) {
      console.error('handleSave hatası:', error);
      console.error('Error response:', error.response?.data);
      alert('Menü kaydedilirken bir hata oluştu: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleDelete = async (id) => {
    if (!confirm('Bu menüyü silmek istediğinize emin misiniz?')) return;

    try {
      const response = await adminApiFetch(`${apiBase}/backend/admin_api.php?action=deleteMenu`, {
        method: 'POST',
        body: JSON.stringify({ id })
      });
      
      console.log('Delete response status:', response.status);
      console.log('Delete response ok:', response.ok);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Delete error response:', errorText);
        try {
          const errorJson = JSON.parse(errorText);
          alert('Menü silinirken bir hata oluştu: ' + (errorJson.message || 'Bilinmeyen hata'));
        } catch (e) {
          alert('Menü silinirken bir hata oluştu: ' + errorText);
        }
        return;
      }
      
      const result = await response.json();
      console.log('Delete response:', result);
      if (result.status === 'error') {
        alert('Menü silinirken bir hata oluştu: ' + (result.message || 'Bilinmeyen hata'));
        return;
      }
      await fetchMenus();
    } catch (error) {
      console.error('Delete error:', error);
      alert('Menü silinirken bir hata oluştu: ' + (error.message || 'Bilinmeyen hata'));
    }
  };

  const handleToggleActive = async (menu) => {
    try {
      await adminApiFetch(`${apiBase}/backend/admin_api.php?action=updateMenu`, {
        method: 'POST',
        body: JSON.stringify({
          id: menu.id,
          is_active: menu.is_active ? 0 : 1
        })
      });
      await fetchMenus();
    } catch (error) {
      // Hata sessizce yok sayılıyor
    }
  };

  const handleMoveOrder = async (menu, direction) => {
    try {
      const response = await adminApiFetch(`${apiBase}/backend/admin_api.php?action=moveMenuOrder`, {
        method: 'POST',
        body: JSON.stringify({
          id: menu.id,
          direction: direction,
          type: menu.type
        })
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Move order error response:', errorText);
        try {
          const errorJson = JSON.parse(errorText);
          alert('Menü sırası güncellenemedi: ' + (errorJson.message || 'Bilinmeyen hata'));
        } catch (e) {
          alert('Menü sırası güncellenemedi: ' + errorText);
        }
        return;
      }
      
      const result = await response.json();
      console.log('Move order result:', result);
      
      if (result && result.status === 'success') {
        // Menüleri yeniden yükle - state güncellenene kadar bekle
        setLoading(true);
        await fetchMenus();
        // Kısa bir gecikme ekle ki state tamamen güncellensin
        await new Promise(resolve => setTimeout(resolve, 100));
      } else {
        alert('Menü sırası güncellenemedi: ' + (result.message || 'Bilinmeyen hata'));
      }
    } catch (error) {
      console.error('Move order error:', error);
      alert('Menü sırası güncellenirken bir hata oluştu: ' + (error.message || 'Bilinmeyen hata'));
    }
  };

  const toggleExpand = (menuId) => {
    const newExpanded = new Set(expandedMenus);
    if (newExpanded.has(menuId)) {
      newExpanded.delete(menuId);
    } else {
      newExpanded.add(menuId);
    }
    setExpandedMenus(newExpanded);
  };

  const buildMenuTree = (menus) => {
    const menuMap = new Map();
    const rootMenus = [];

    menus.forEach(menu => {
      menuMap.set(menu.id, { ...menu, children: [] });
    });

    menus.forEach(menu => {
      const menuItem = menuMap.get(menu.id);
      if (menu.parent_id) {
        const parent = menuMap.get(menu.parent_id);
        if (parent) {
          parent.children.push(menuItem);
        } else {
          rootMenus.push(menuItem);
        }
      } else {
        rootMenus.push(menuItem);
      }
    });

    // Root menüleri sırala
    rootMenus.sort((a, b) => {
      if (a.order_index !== b.order_index) {
        return a.order_index - b.order_index;
      }
      // Aynı order_index ise id'ye göre sırala
      return a.id - b.id;
    });
    
    // Alt menüleri de sırala (recursive)
    const sortChildren = (menuItems) => {
      menuItems.forEach(menu => {
        if (menu.children && menu.children.length > 0) {
          menu.children.sort((a, b) => {
            if (a.order_index !== b.order_index) {
              return a.order_index - b.order_index;
            }
            return a.id - b.id;
          });
          sortChildren(menu.children);
        }
      });
    };
    
    sortChildren(rootMenus);
    
    return rootMenus;
  };

  const separateMenusBySide = (menus) => {
    // Navbar menülerini al
    const navbarMenus = menus.filter(m => m.type === 'navbar');
    const footerMenus = menus.filter(m => m.type === 'footer');
    
    // Tüm navbar menülerini al (sol/sağ ayrımı yok) ve sırala
    const allNavbarMenus = navbarMenus
      .filter(m => m.parent_id === null)
      .sort((a, b) => {
        if (a.order_index !== b.order_index) {
          return a.order_index - b.order_index;
        }
        // Aynı order_index ise id'ye göre sırala
        return a.id - b.id;
      });
    
    // Alt menüleri sol ve sağ olarak ayır (mega menu içi için)
    const navbarMenusWithChildren = allNavbarMenus.map(menu => {
      const allChildren = navbarMenus
        .filter(m => m.parent_id === menu.id)
        .sort((a, b) => {
          if (a.order_index !== b.order_index) {
            return a.order_index - b.order_index;
          }
          return a.id - b.id;
        });
      
      // Sol taraf alt menüleri: column = 1 veya section yok/null
      const leftChildren = allChildren.filter(m => 
        (m.mega_menu_column === 1 || m.mega_menu_column === null) && 
        (m.mega_menu_section === null || m.mega_menu_section === '' || m.mega_menu_section !== 'right')
      ).sort((a, b) => {
        if (a.order_index !== b.order_index) {
          return a.order_index - b.order_index;
        }
        return a.id - b.id;
      });
      
      // Sağ taraf alt menüleri: section = 'right'
      const rightChildren = allChildren.filter(m => 
        m.mega_menu_section === 'right'
      ).sort((a, b) => {
        if (a.order_index !== b.order_index) {
          return a.order_index - b.order_index;
        }
        return a.id - b.id;
      });
      
      return { 
        ...menu, 
        children: allChildren,
        leftChildren: leftChildren,
        rightChildren: rightChildren
      };
    });
    
    // Footer menülerini de sırala
    const sortedFooterMenus = buildMenuTree(footerMenus);
    
    return {
      navbar: navbarMenusWithChildren,
      footer: sortedFooterMenus
    };
  };

  const renderMenuTree = (menuItems, level = 0) => {
    const filtered = filterType === 'all' 
      ? menuItems 
      : menuItems.filter(m => m.type === filterType);
    
    // Menüleri order_index'e göre sırala (eğer sıralanmamışsa)
    const sorted = [...filtered].sort((a, b) => {
      const orderA = a.order_index || 0;
      const orderB = b.order_index || 0;
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      // Aynı order_index ise id'ye göre sırala
      return (a.id || 0) - (b.id || 0);
    });

    return sorted.map((menu) => {
      const hasChildren = menu.children && menu.children.length > 0;
      const isExpanded = expandedMenus.has(menu.id);

      return (
        <div key={menu.id} className="border-b border-gray-200">
          <div
            className={`flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-0 p-3 sm:p-4 hover:bg-gray-50 ${
              level > 0 ? 'bg-gray-50' : ''
            }`}
            style={{ paddingLeft: `${level * 12 + 8}px` }}
          >
            <div className="flex items-center space-x-2 sm:space-x-3 flex-1 min-w-0">
              {hasChildren && (
                <button
                  onClick={() => toggleExpand(menu.id)}
                  className="p-1 hover:bg-gray-200 rounded flex-shrink-0"
                >
                  {isExpanded ? (
                    <ChevronDown className="w-3 h-3 sm:w-4 sm:h-4" />
                  ) : (
                    <ChevronRight className="w-3 h-3 sm:w-4 sm:h-4" />
                  )}
                </button>
              )}
              {!hasChildren && <div className="w-4 sm:w-6 flex-shrink-0" />}

              <div className="flex items-center space-x-2 sm:space-x-3 flex-1 min-w-0">
                <MenuIcon className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-1 sm:gap-2">
                    <span className="font-medium text-sm sm:text-base text-gray-900 truncate">{menu.title}</span>
                    {menu.is_mega_menu && (
                      <Badge variant="secondary" className="text-[10px] sm:text-xs">Mega Menu</Badge>
                    )}
                    {menu.is_promo_card && (
                      <Badge variant="outline" className="text-[10px] sm:text-xs bg-yellow-50">Promo</Badge>
                    )}
                    {menu.is_special && (
                      <Badge variant="outline" className="text-[10px] sm:text-xs bg-purple-50">Özel</Badge>
                    )}
                    {menu.mega_menu_column && menu.mega_menu_column > 0 && (
                      <Badge variant="outline" className="text-[10px] sm:text-xs bg-green-50">Kolon {menu.mega_menu_column}</Badge>
                    )}
                  </div>
                  {menu.url && (
                    <div className="text-xs sm:text-sm text-gray-500 flex items-center space-x-1 mt-1 truncate">
                      <LinkIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3 flex-shrink-0" />
                      <span className="truncate">{menu.url}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end gap-1 sm:gap-2 flex-wrap">
              <Button
                variant="ghost"
                size="sm"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleMoveOrder(menu, 'up');
                }}
                title="Yukarı taşı"
                type="button"
                className="h-7 w-7 sm:h-8 sm:w-8 p-0"
              >
                <ArrowUp className="w-3 h-3 sm:w-4 sm:h-4" />
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleMoveOrder(menu, 'down');
                }}
                title="Aşağı taşı"
                type="button"
                className="h-7 w-7 sm:h-8 sm:w-8 p-0"
              >
                <ArrowDown className="w-3 h-3 sm:w-4 sm:h-4" />
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleToggleActive(menu)}
                title={menu.is_active ? 'Pasif yap' : 'Aktif yap'}
                className="h-7 w-7 sm:h-8 sm:w-8 p-0"
              >
                {menu.is_active ? (
                  <Eye className="w-3 h-3 sm:w-4 sm:h-4 text-green-600" />
                ) : (
                  <EyeOff className="w-3 h-3 sm:w-4 sm:h-4 text-gray-400" />
                )}
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleEdit(menu)}
                className="h-7 w-7 sm:h-8 sm:w-8 p-0"
              >
                <Edit className="w-3 h-3 sm:w-4 sm:h-4" />
              </Button>
              {/* Sekmeleri Düzenle butonu - sadece has_tabs veya hosting_tabs varsa göster */}
              {(menu.has_tabs || menu.hosting_tabs) && menu.is_mega_menu && !menu.parent_id && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // Generic tabs editor'ü aç
                    let tabs = menu.hosting_tabs || {};
                    
                    // Eğer string ise parse et
                    if (typeof tabs === 'string') {
                      try {
                        tabs = JSON.parse(tabs);
                      } catch (e) {
                        console.error('Error parsing hosting_tabs:', e);
                        tabs = {};
                      }
                    }
                    
                    // Eğer hosting_tabs bir obje içinde tabs property'si varsa, onu kullan
                    if (tabs.tabs && typeof tabs.tabs === 'object') {
                      tabs = tabs.tabs;
                    }
                    
                    // Eğer hala boşsa, default yapı oluştur
                    if (!tabs || Object.keys(tabs).length === 0) {
                      tabs = {
                        tab1: { title: 'Yeni Sekme 1', order: 0, items: [] },
                        tab2: { title: 'Yeni Sekme 2', order: 1, items: [] }
                      };
                    }
                    
                    // Eğer order değerleri yoksa, otomatik olarak ekle
                    const tabKeys = Object.keys(tabs);
                    tabKeys.forEach((tabKey, index) => {
                      if (tabs[tabKey] && (tabs[tabKey].order === undefined || tabs[tabKey].order === null)) {
                        tabs[tabKey] = { ...tabs[tabKey], order: index };
                      }
                    });
                    
                    setEditingTabs(tabs);
                    setEditingTabsMenuId(menu.id);
                    setShowTabsEditor(true);
                  }}
                  className="h-7 w-7 sm:h-8 sm:w-8 p-0 text-purple-600 hover:text-purple-700"
                  title="Sekmeleri Düzenle"
                >
                  <Layers className="w-3 h-3 sm:w-4 sm:h-4" />
                </Button>
              )}
              <Button
                variant="ghost"
                size="sm"
                onClick={() => handleDelete(menu.id)}
                className="text-red-600 hover:text-red-700 h-7 w-7 sm:h-8 sm:w-8 p-0"
              >
                <Trash2 className="w-3 h-3 sm:w-4 sm:h-4" />
              </Button>
            </div>
          </div>

              {hasChildren && isExpanded && (
            <div>
              {/* Mega menu için sol ve sağ taraf ayrımı */}
              {menu.leftChildren && menu.rightChildren ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 p-3 sm:p-4 bg-gray-50">
                  <div>
                    <div className="text-xs font-semibold text-gray-500 mb-2 px-2">Sol Taraf</div>
                    {renderMenuTree(menu.leftChildren, level + 1)}
                  </div>
                  <div>
                    <div className="text-xs font-semibold text-gray-500 mb-2 px-2">Sağ Taraf</div>
                    {renderMenuTree(menu.rightChildren, level + 1)}
                  </div>
                </div>
              ) : (
                renderMenuTree(menu.children, level + 1)
              )}
            </div>
          )}
          
          {/* Hosting Mega Menu - Sekme Yönetimi (sadece hosting menüsü için) */}
          {menu.menu_key === 'hosting' && menu.is_mega_menu && (
            <div className="border-t border-gray-200 bg-green-50">
              <div className="p-4">
                <div className="flex items-center justify-between mb-3 gap-2">
                  <div className="flex items-center gap-1 sm:gap-2 flex-1 min-w-0">
                    {/* Sol taraf - Kontrol butonları */}
                    <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleMoveOrder(menu, 'up');
                        }}
                        title="Yukarı taşı"
                        type="button"
                        className="h-7 w-7 sm:h-8 sm:w-8 p-0"
                      >
                        <ArrowUp className="w-3 h-3 sm:w-4 sm:h-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handleMoveOrder(menu, 'down');
                        }}
                        title="Aşağı taşı"
                        type="button"
                        className="h-7 w-7 sm:h-8 sm:w-8 p-0"
                      >
                        <ArrowDown className="w-3 h-3 sm:w-4 sm:h-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => handleToggleActive(menu)}
                        title={menu.is_active ? 'Pasif yap' : 'Aktif yap'}
                        className="h-7 w-7 sm:h-8 sm:w-8 p-0"
                      >
                        {menu.is_active ? (
                          <Eye className="w-3 h-3 sm:w-4 sm:h-4 text-green-600" />
                        ) : (
                          <EyeOff className="w-3 h-3 sm:w-4 sm:h-4 text-gray-400" />
                        )}
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => handleEdit(menu)}
                        className="h-7 w-7 sm:h-8 sm:w-8 p-0"
                      >
                        <Edit className="w-3 h-3 sm:w-4 sm:h-4" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => handleDelete(menu.id)}
                        className="text-red-600 hover:text-red-700 h-7 w-7 sm:h-8 sm:w-8 p-0"
                      >
                        <Trash2 className="w-3 h-3 sm:w-4 sm:h-4" />
                      </Button>
                    </div>
                    
                    {/* Orta - Başlık */}
                    <div className="flex items-center space-x-2 flex-1 min-w-0">
                      <Server className="w-5 h-5 text-green-600 flex-shrink-0" />
                      <span className="text-green-900 font-semibold truncate">Hosting Mega Menu - Sekme Yönetimi</span>
                    </div>
                  </div>
                  
                  {/* Sağ taraf - Sekmeleri Düzenle butonu */}
                  <div className="flex-shrink-0">
                    <Button 
                      onClick={() => {
                        // Hosting tabs düzenleme modalını aç
                        let parsedData = menu.hosting_tabs ? 
                          (typeof menu.hosting_tabs === 'string' ? JSON.parse(menu.hosting_tabs) : menu.hosting_tabs) :
                          {
                            domain: { title: 'Domain', order: 0, items: [{ name: 'Domain Sorgulama', path: '/alan-adi', description: "0,99$'dan başlayan fiyatlarla" }] },
                            hosting: { title: 'Hosting', order: 1, items: [
                              { name: 'Sınırsız Web Hosting', path: '/hosting', description: "0,69$'dan başlayan fiyatlarla" },
                              { name: 'WordPress Hosting', path: '/wordpress-hosting', description: "0,99$'dan başlayan fiyatlarla" },
                              { name: 'E-Ticaret Hosting', path: '/eticaret-hosting', description: 'Hazır sanal-pos entegrasyonu ile.' },
                              { name: 'Bayi Hosting', path: '/bayi-hosting', description: 'Müşterilerinize hosting hizmeti verin' }
                            ]},
                            ssl: { title: 'SSL', order: 2, items: [
                              { name: 'Tüm SSL Sertifikaları', path: '/ssl/ssl-sertifikasi', description: "15,99$'a anında kurulum hemen teslim SSL Sertifikası" },
                              { name: 'Hızlı Kurulum (DV) SSL', path: '/ssl/ssl-sertifikasi#hizlikurulum', description: 'Belgesiz, anında kurulum SEO dostu SSL sertifikası' },
                              { name: 'Kurumsal (OV) SSL', path: '/ssl/ssl-sertifikasi#premiumSsl', description: 'Kurulum belgelerinin yer aldığı, yüksek sigortalı SSL Sertifikası' },
                              { name: 'Gelişmiş Kurumsal (EV) SSL', path: '/ssl/ssl-sertifikasi#evSsl', description: 'Yüksek güvenlik ve kapsamlı doğrulama sunan SSL Sertifikası' }
                            ]},
                            server: { title: 'Sunucu', order: 3, items: [
                              { name: 'VPS Server', path: '/vps-sunucu', description: 'Sanal sunucuda ekonomik ve esnek çözümler' },
                              { name: 'VDS Server', path: '/vds-sunucu', description: '29,99$/Ay Sanallaştırmada yüksek performans için en iyi çözüm' },
                              { name: 'Kurumsal Server', path: '/kurumsal-sunucu', description: 'Kurumsal performans, en yüksek kaynak' }
                            ]}
                          };
                        
                        // Right verisini ayır
                        const { right, ...hostingTabs } = parsedData;
                        
                        // Eğer order değerleri yoksa, otomatik olarak ekle
                        const tabKeys = Object.keys(hostingTabs);
                        tabKeys.forEach((tabKey, index) => {
                          if (hostingTabs[tabKey] && (hostingTabs[tabKey].order === undefined || hostingTabs[tabKey].order === null)) {
                            hostingTabs[tabKey] = { ...hostingTabs[tabKey], order: index };
                          }
                        });
                        
                        setEditingHostingTabs(hostingTabs);
                        setEditingHostingRight(right || null);
                        setEditingHostingMenuId(menu.id);
                        setShowHostingTabsEditor(true);
                      }}
                      size="sm"
                      className="bg-green-600 hover:bg-green-700"
                    >
                      <Edit className="w-4 h-4 mr-2" />
                      Sekmeleri Düzenle
                    </Button>
                  </div>
                </div>
                <div className="text-sm text-gray-700">
                  <p className="mb-2">Hosting mega menu'sünde <strong>4 sekme</strong> bulunuyor:</p>
                  <div className="flex flex-wrap gap-2">
                    {(() => {
                      const tabs = menu.hosting_tabs ? 
                        (typeof menu.hosting_tabs === 'string' ? JSON.parse(menu.hosting_tabs) : menu.hosting_tabs) :
                        { domain: {}, hosting: {}, ssl: {}, server: {} };
                      return Object.keys(tabs).map(tabKey => (
                        <Badge key={tabKey} variant="outline" className="bg-white">
                          {tabs[tabKey]?.title || tabKey}
                        </Badge>
                      ));
                    })()}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    });
  };

  const filteredMenus = filterType === 'all' 
    ? menus 
    : menus.filter(m => m.type === filterType);

  const menuTree = buildMenuTree(filteredMenus);
  const separatedMenus = separateMenusBySide(menus);
  
  // Footer menülerini al (tüm footer menüleri, hem root hem children)
  const allFooterMenus = menus.filter(m => m.type === 'footer');

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Menüler yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full px-2 sm:px-4 lg:px-6 py-4 sm:py-6 lg:py-10 space-y-4 sm:space-y-6 overflow-x-hidden">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
        <div>
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-gray-900">Menü Yönetimi</h1>
          <p className="text-xs sm:text-sm text-gray-500 mt-1">
            Navbar ve footer menülerini düzenleyin
          </p>
        </div>
        <Button onClick={handleCreate} size="sm" className="w-full sm:w-auto text-xs sm:text-sm">
          <Plus className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
          Yeni Menü Ekle
        </Button>
      </div>

      {/* Filter */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <Label className="text-xs sm:text-sm">Filtrele:</Label>
        <div className="flex flex-wrap gap-2">
          <Button
            variant={filterType === 'all' ? 'default' : 'outline'}
            size="sm"
            onClick={() => setFilterType('all')}
            className="text-xs sm:text-sm"
          >
            Tümü
          </Button>
          <Button
            variant={filterType === 'navbar' ? 'default' : 'outline'}
            size="sm"
            onClick={() => setFilterType('navbar')}
            className="text-xs sm:text-sm"
          >
            Navbar
          </Button>
          <Button
            variant={filterType === 'footer' ? 'default' : 'outline'}
            size="sm"
            onClick={() => setFilterType('footer')}
            className="text-xs sm:text-sm"
          >
            Footer
          </Button>
        </div>
      </div>

      {/* Navbar Menus */}
      {(filterType === 'all' || filterType === 'navbar') && (
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center space-x-2">
              <MenuIcon className="w-5 h-5" />
              <span>Navbar Menüleri ({separatedMenus.navbar.length})</span>
            </CardTitle>
          </CardHeader>
          <CardContent className="p-0">
            <div className="divide-y divide-gray-200">
              {separatedMenus.navbar.length > 0 ? (
                renderMenuTree(separatedMenus.navbar)
              ) : (
                <div className="p-8 text-center text-gray-500">
                  Navbar menüsü yok
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Footer Settings */}
      {(filterType === 'all' || filterType === 'footer') && (
        <Card className="mb-6">
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <Layout className="w-5 h-5" />
                <span>Footer Ayarları</span>
              </div>
              <Button 
                onClick={handleSaveFooterSettings}
                disabled={footerSettingsLoading}
                size="sm"
              >
                <Save className="w-4 h-4 mr-2" />
                {footerSettingsLoading ? 'Kaydediliyor...' : 'Kaydet'}
              </Button>
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3 sm:space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div>
                <Label className="text-xs sm:text-sm">Logo URL</Label>
                <div className="flex flex-col sm:flex-row gap-2 mt-1">
                  <Input
                    value={footerSettings.logo_url || ''}
                    onChange={(e) => {
                      setFooterSettings({ ...footerSettings, logo_url: e.target.value });
                      setLogoError(false); // Reset error when URL changes
                    }}
                    placeholder="/website-al-logo.png"
                    className="text-xs sm:text-sm"
                  />
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => openMediaLibrary('footer_logo')}
                    className="text-xs sm:text-sm"
                  >
                    <ImageIcon className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    Medya
                  </Button>
                </div>
                <p className="text-xs text-gray-500 mt-1">Footer'daki logo görseli</p>
              </div>
              <div>
                <Label className="text-xs sm:text-sm">Navbar Logo URL</Label>
                <div className="flex flex-col sm:flex-row gap-2 mt-1">
                  <Input
                    value={footerSettings.navbar_logo_url || ''}
                    onChange={(e) =>
                      setFooterSettings({ ...footerSettings, navbar_logo_url: e.target.value })
                    }
                    placeholder="/website-al-koyu.png"
                    className="text-xs sm:text-sm"
                  />
                  <Button
                    type="button"
                    variant="outline"
                    size="sm"
                    onClick={() => openMediaLibrary('navbar_logo')}
                    className="text-xs sm:text-sm"
                  >
                    <ImageIcon className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    Medya
                  </Button>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Üst menüde (navbar) gösterilecek logo görseli
                </p>
              </div>
              <div>
                <Label className="text-xs sm:text-sm">Şirket Adı</Label>
                <Input
                  value={footerSettings.company_name || ''}
                  onChange={(e) => setFooterSettings({ ...footerSettings, company_name: e.target.value })}
                  placeholder="Website Al"
                  className="text-xs sm:text-sm mt-1"
                />
                <p className="text-xs text-gray-500 mt-1">Logo alt text</p>
              </div>
            </div>

            <div>
              <Label className="text-xs sm:text-sm">Açıklama</Label>
              <Textarea
                value={footerSettings.description || ''}
                onChange={(e) => setFooterSettings({ ...footerSettings, description: e.target.value })}
                placeholder="Türkiye'nin en büyük B2B freelance platformu..."
                rows={3}
                className="text-xs sm:text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">Logo altında gösterilecek açıklama metni</p>
            </div>

            <div>
              <Label className="text-xs sm:text-sm">Bülten Metni (4. Sütun)</Label>
              <Textarea
                value={footerSettings.newsletter_text || ''}
                onChange={(e) => setFooterSettings({ ...footerSettings, newsletter_text: e.target.value })}
                placeholder="Son güncellemeler ve özel fırsatlardan haberdar olmak için bültenimize abone olun."
                rows={3}
                className="text-xs sm:text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">4. sütunda görünen bülten metni</p>
            </div>

            <div>
              <Label className="text-xs sm:text-sm">Copyright Metni</Label>
              <Input
                value={footerSettings.copyright_text || ''}
                onChange={(e) => setFooterSettings({ ...footerSettings, copyright_text: e.target.value })}
                placeholder="© 2024 Website Al. Tüm hakları saklıdır."
                className="text-xs sm:text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">Footer alt kısmındaki copyright metni</p>
            </div>

            {/* Copyright Menü Öğeleri */}
            <div>
              <Label className="text-xs sm:text-sm">Copyright Menü Öğeleri</Label>
              <p className="text-xs text-gray-500 mt-1 mb-3">Copyright metninin sağında gösterilecek menü öğeleri</p>
              
              <div className="space-y-3 border border-gray-200 rounded-lg p-4 bg-gray-50">
                {(footerSettings.copyright_links || []).map((link, index) => (
                  <div key={index} className="flex gap-2 items-center">
                    <div className="flex-1 grid grid-cols-2 gap-2">
                      <Input
                        value={link.title || ""}
                        onChange={(e) => {
                          const newLinks = [...(footerSettings.copyright_links || [])];
                          newLinks[index].title = e.target.value;
                          setFooterSettings({ ...footerSettings, copyright_links: newLinks });
                        }}
                        placeholder="Menü Başlığı"
                        className="text-xs sm:text-sm"
                      />
                      <Input
                        value={link.url || ""}
                        onChange={(e) => {
                          const newLinks = [...(footerSettings.copyright_links || [])];
                          newLinks[index].url = e.target.value;
                          setFooterSettings({ ...footerSettings, copyright_links: newLinks });
                        }}
                        placeholder="/privacy"
                        className="text-xs sm:text-sm"
                      />
                    </div>
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      onClick={() => {
                        const newLinks = [...(footerSettings.copyright_links || [])];
                        newLinks.splice(index, 1);
                        setFooterSettings({ ...footerSettings, copyright_links: newLinks });
                      }}
                      className="text-red-600 hover:text-red-700 hover:bg-red-50"
                    >
                      <Trash2 className="w-3 h-3 sm:w-4 sm:h-4" />
                    </Button>
                  </div>
                ))}
                
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={() => {
                    const newLinks = [...(footerSettings.copyright_links || []), { title: "", url: "" }];
                    setFooterSettings({ ...footerSettings, copyright_links: newLinks });
                  }}
                  className="w-full mt-2"
                >
                  <Plus className="w-3 h-3 sm:w-4 sm:h-4 mr-2" />
                  Yeni Menü Öğesi Ekle
                </Button>
              </div>
            </div>

            {/* Önizleme */}
            {footerSettings.logo_url && (
              <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                <Label className="mb-2 block">Logo Önizleme:</Label>
                {logoError ? (
                  <p className="text-red-500 text-sm">Logo yüklenemedi. URL'yi kontrol edin.</p>
                ) : (
                  <img 
                    src={footerSettings.logo_url} 
                    alt={footerSettings.company_name || 'Logo'} 
                    className="w-[200px] h-12 object-contain"
                    onError={() => setLogoError(true)}
                    onLoad={() => setLogoError(false)}
                  />
                )}
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {/* Footer Menus - 2. ve 3. sütun */}
      {(filterType === 'all' || filterType === 'footer') && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {/* 2. Sütun - Hizmetlerimiz */}
          <Card>
            <CardHeader className="bg-blue-50">
              <CardTitle className="flex items-center justify-between text-sm">
                <div className="flex items-center space-x-2">
                  <FileText className="w-4 h-4" />
                  <span>2. Sütun - Hizmetlerimiz ({allFooterMenus.filter(m => m.footer_column == 2 || parseInt(m.footer_column) === 2).length})</span>
                </div>
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  onClick={() => handleCreateFooterItem(2)}
                  title="Bu sütuna yeni menü ekle"
                >
                  <Plus className="w-4 h-4" />
                </Button>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <div className="divide-y divide-gray-200">
                {allFooterMenus.filter(m => m.footer_column == 2 || parseInt(m.footer_column) === 2).length > 0 ? (
                  renderMenuTree(buildMenuTree(allFooterMenus.filter(m => m.footer_column == 2 || parseInt(m.footer_column) === 2)))
                ) : (
                  <div className="p-6 text-center text-gray-500 text-sm">
                    Bu sütunda menü yok
                  </div>
                )}
              </div>
            </CardContent>
          </Card>

          {/* 3. Sütun - Kurumsal */}
          <Card>
            <CardHeader className="bg-purple-50">
              <CardTitle className="flex items-center justify-between text-sm">
                <div className="flex items-center space-x-2">
                  <FileText className="w-4 h-4" />
                  <span>3. Sütun - Kurumsal ({allFooterMenus.filter(m => m.footer_column == 3 || parseInt(m.footer_column) === 3).length})</span>
                </div>
                <Button
                  type="button"
                  variant="outline"
                  size="icon"
                  onClick={() => handleCreateFooterItem(3)}
                  title="Bu sütuna yeni menü ekle"
                >
                  <Plus className="w-4 h-4" />
                </Button>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <div className="divide-y divide-gray-200">
                {allFooterMenus.filter(m => m.footer_column == 3 || parseInt(m.footer_column) === 3).length > 0 ? (
                  renderMenuTree(buildMenuTree(allFooterMenus.filter(m => m.footer_column == 3 || parseInt(m.footer_column) === 3)))
                ) : (
                  <div className="p-6 text-center text-gray-500 text-sm">
                    Bu sütunda menü yok
                  </div>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Form Modal */}
      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2 sm:p-4">
          <Card className="w-full max-w-2xl max-h-[95vh] sm:max-h-[90vh] overflow-y-auto">
            <CardHeader className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 p-3 sm:p-6">
              <CardTitle className="text-base sm:text-lg">{editingMenu ? 'Menü Düzenle' : 'Yeni Menü Ekle'}</CardTitle>
              <Button variant="ghost" size="sm" onClick={() => setShowForm(false)} className="self-end sm:self-auto">
                <X className="w-4 h-4" />
              </Button>
            </CardHeader>
            <CardContent className="space-y-3 sm:space-y-4 p-3 sm:p-6">
              {/* Info Banner - Filtre Bilgisi */}
              {!editingMenu && filterType !== 'all' && (
                <div className={`p-3 rounded-lg ${
                  filterType === 'navbar' 
                    ? 'bg-blue-50 border border-blue-200' 
                    : 'bg-purple-50 border border-purple-200'
                }`}>
                  <p className="text-sm">
                    ℹ️ <strong>{filterType === 'navbar' ? 'Navbar' : 'Footer'}</strong> menüsü ekliyorsunuz. 
                    Kaydettiğinizde bu menü <strong>{filterType === 'navbar' ? 'üst navigasyon' : 'alt footer'}</strong> kısmında görünecektir.
                  </p>
                </div>
              )}
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                <div>
                  <Label className="text-xs sm:text-sm">Başlık *</Label>
                  <Input
                    value={formData.title || ''}
                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                    placeholder="Menü başlığı"
                    className="text-xs sm:text-sm"
                  />
                </div>
                <div>
                  <Label className="text-xs sm:text-sm">URL</Label>
                  <div className="relative">
                    <Input
                      value={formData.url || ''}
                      onChange={(e) => setFormData({ ...formData, url: e.target.value })}
                      placeholder="/sayfa-yolu"
                      className="text-xs sm:text-sm pr-10"
                    />
                    <Popover open={urlDropdownOpen} onOpenChange={setUrlDropdownOpen}>
                      <PopoverTrigger asChild>
                        <Button
                          type="button"
                          variant="ghost"
                          size="sm"
                          className="absolute right-0 top-0 h-full px-2 hover:bg-transparent"
                          onClick={() => setUrlDropdownOpen(true)}
                        >
                          <ChevronDown className="h-4 w-4 opacity-50" />
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent className="w-[400px] p-0" align="start">
                        <Command>
                          <CommandInput placeholder="URL ara..." className="h-9" />
                          <CommandList>
                            <CommandEmpty>
                              {loadingUrls ? 'Yükleniyor...' : 'URL bulunamadı'}
                            </CommandEmpty>
                            {Object.entries(
                              availableUrls.reduce((acc, url) => {
                                if (!acc[url.category]) {
                                  acc[url.category] = [];
                                }
                                acc[url.category].push(url);
                                return acc;
                              }, {})
                            ).map(([category, urls]) => (
                              <CommandGroup key={category} heading={category}>
                                {urls.map((url) => (
                                  <CommandItem
                                    key={url.path}
                                    value={url.path}
                                    onSelect={() => {
                                      setFormData({ ...formData, url: url.path });
                                      setUrlDropdownOpen(false);
                                    }}
                                    className="flex items-center justify-between"
                                  >
                                    <div className="flex flex-col">
                                      <span className="text-sm">{url.name}</span>
                                      <span className="text-xs text-muted-foreground">{url.path}</span>
                                    </div>
                                  </CommandItem>
                                ))}
                              </CommandGroup>
                            ))}
                          </CommandList>
                        </Command>
                      </PopoverContent>
                    </Popover>
                  </div>
                </div>
              </div>

              <div>
                <Label className="text-xs sm:text-sm">Açıklama</Label>
                <Textarea
                  value={formData.description || ''}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  placeholder="Menü açıklaması"
                  rows={2}
                  className="text-xs sm:text-sm"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                {/* Tip selectbox'ı sadece ana menülerde göster */}
                {!formData.parent_id && (
                  <div>
                    <Label className="text-xs sm:text-sm">Tip *</Label>
                    <select
                      className="w-full px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md"
                      value={formData.type}
                      onChange={(e) => setFormData({ ...formData, type: e.target.value, parent_id: null })}
                    >
                      <option value="navbar">Navbar</option>
                      <option value="footer">Footer</option>
                    </select>
                  </div>
                )}
                <div>
                  <Label className="text-xs sm:text-sm">Sıra</Label>
                  <Input
                    type="number"
                    value={formData.order_index}
                    onChange={(e) => setFormData({ ...formData, order_index: parseInt(e.target.value) || 0 })}
                    className="text-xs sm:text-sm"
                  />
                </div>
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                <div>
                  <Label className="text-xs sm:text-sm">Ana Menü (Parent)</Label>
                  <select
                    className="w-full px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md mb-1"
                    value={formData.parent_id || ''}
                    onChange={(e) => {
                      const parentId = e.target.value ? parseInt(e.target.value) : null;
                      const parentMenu = menus.find(m => m.id == parentId);
                      console.log('Parent seçildi:', parentId, parentMenu);
                      setFormData({ 
                        ...formData, 
                        parent_id: parentId,
                        // Parent'ın tipini miras al
                        type: parentMenu ? parentMenu.type : formData.type
                      });
                    }}
                  >
                    <option value="">Ana Menü Yok (Üst Seviye)</option>
                    {(() => {
                      // Parent menüleri filtrele ve unique hale getir
                      const parentMenus = menus
                        .filter(m => m.parent_id === null && m.type === formData.type);
                      
                      // ID'ye göre unique yap (duplicate kayıtları engelle)
                      const uniqueMenus = Array.from(
                        new Map(parentMenus.map(m => [m.id, m])).values()
                      );
                      
                      console.log(`${formData.type} parent menüleri:`, uniqueMenus.length);
                      
                      return uniqueMenus.map((menu) => (
                        <option key={menu.id} value={menu.id}>
                          {menu.title} ({menu.menu_key || 'key yok'})
                        </option>
                      ));
                    })()}
                  </select>
                  <p className="text-xs text-gray-500 mt-1">
                    Bu menüyü hangi ana menünün altına eklemek istersiniz?
                  </p>
                </div>
                <div>
                  <Label className="text-xs sm:text-sm">Menu Key</Label>
                  <Input
                    value={formData.menu_key || ''}
                    onChange={(e) => setFormData({ ...formData, menu_key: e.target.value })}
                    placeholder="Özel key (örn. domain, website...)"
                    className="text-xs sm:text-sm"
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    İsteğe bağlı: Menü için benzersiz bir anahtar kelime
                  </p>
                </div>
              </div>

              {/* İkon Seçimi */}
              <div className="col-span-2">
                <Label className="text-xs sm:text-sm">İkon Seçimi</Label>
                {/* Seçili İkon */}
                {formData.icon && (
                  <div className="mt-2 mb-3 flex items-center gap-2 p-3 bg-purple-50 border border-purple-200 rounded-lg">
                    {(() => {
                      const IconComponent = getIconComponent(formData.icon);
                      return <IconComponent className="w-6 h-6 text-purple-600" />;
                    })()}
                    <span className="font-medium text-purple-900">{formData.icon}</span>
                    <button
                      type="button"
                      onClick={() => setFormData({ ...formData, icon: '' })}
                      className="ml-auto text-xs text-gray-500 hover:text-gray-700"
                    >
                      Temizle
                    </button>
                  </div>
                )}
                {/* İkon Grid */}
                <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-2 mt-2 max-h-64 overflow-y-auto p-2 border border-gray-200 rounded-lg bg-gray-50">
                  {iconOptions.map((icon) => {
                    const IconComponent = icon.component;
                    const isSelected = formData.icon === icon.name;
                    return (
                      <button
                        key={icon.name}
                        type="button"
                        onClick={() => setFormData({ ...formData, icon: icon.name })}
                        className={`flex flex-col items-center justify-center p-3 rounded-lg border-2 transition-all hover:shadow-md ${
                          isSelected
                            ? 'border-purple-600 bg-purple-50 scale-105'
                            : 'border-gray-300 bg-white hover:border-purple-400'
                        }`}
                        title={icon.name}
                      >
                        <IconComponent className={`w-6 h-6 ${isSelected ? 'text-purple-600' : 'text-gray-600'}`} />
                        <span className="text-[9px] mt-1 text-gray-500 text-center leading-tight">{icon.name}</span>
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                <div>
                  <Label className="text-xs sm:text-sm">Target</Label>
                  <select
                    className="w-full px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded-md"
                    value={formData.target}
                    onChange={(e) => setFormData({ ...formData, target: e.target.value })}
                  >
                    <option value="_self">Aynı Sekme</option>
                    <option value="_blank">Yeni Sekme</option>
                  </select>
                </div>
              </div>

              {/* Renk Ayarları */}
              <div className="border border-gray-200 rounded-lg p-4 space-y-4">
                <Label className="text-base sm:text-lg font-semibold">Renk Ayarları</Label>
                
                {/* Metin Rengi */}
                <div>
                  <Label className="text-xs sm:text-sm">Metin Rengi</Label>
                  <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2 mt-2">
                    {navbarColorOptions.text.map((color) => (
                      <button
                        key={color.value}
                        type="button"
                        onClick={() => setFormData({ ...formData, text_color: color.value })}
                        className={`h-10 rounded-lg border-2 transition-all flex items-center justify-center ${
                          formData.text_color === color.value
                            ? 'border-gray-800 scale-105 shadow-md'
                            : 'border-gray-300 hover:border-gray-500'
                        } ${color.preview === '#ffffff' || color.preview === '#f9fafb' ? 'ring-1 ring-gray-300' : ''}`}
                        style={{ backgroundColor: color.preview }}
                        title={color.label}
                      >
                        <span className={`text-xs font-medium ${color.preview === '#ffffff' || color.preview === '#f9fafb' ? 'text-gray-700' : 'text-white drop-shadow-md'}`}>
                          {color.label}
                        </span>
                      </button>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    Seçili: {navbarColorOptions.text.find(c => c.value === formData.text_color)?.label || formData.text_color || 'Yok'}
                  </p>
                </div>

                {/* Hover Rengi */}
                <div>
                  <Label className="text-xs sm:text-sm">Hover Rengi</Label>
                  <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2 mt-2">
                    {navbarColorOptions.hover.map((color) => (
                      <button
                        key={color.value}
                        type="button"
                        onClick={() => setFormData({ ...formData, hover_color: color.value })}
                        className={`h-10 rounded-lg border-2 transition-all flex items-center justify-center ${
                          formData.hover_color === color.value
                            ? 'border-gray-800 scale-105 shadow-md'
                            : 'border-gray-300 hover:border-gray-500'
                        } ${color.preview === '#ffffff' ? 'ring-1 ring-gray-300' : ''}`}
                        style={{ backgroundColor: color.preview }}
                        title={color.label}
                      >
                        <span className={`text-xs font-medium ${color.preview === '#ffffff' ? 'text-gray-700' : 'text-white drop-shadow-md'}`}>
                          {color.label}
                        </span>
                      </button>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    Seçili: {navbarColorOptions.hover.find(c => c.value === formData.hover_color)?.label || formData.hover_color || 'Yok'}
                  </p>
                </div>

                {/* Arka Plan Rengi */}
                <div>
                  <Label className="text-xs sm:text-sm">Arka Plan Rengi</Label>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 mt-2">
                    {navbarColorOptions.bg.map((color) => (
                      <button
                        key={color.value}
                        type="button"
                        onClick={() => setFormData({ ...formData, bg_color: color.value })}
                        className={`h-10 rounded-lg border-2 transition-all flex items-center justify-center ${
                          formData.bg_color === color.value
                            ? 'border-gray-800 scale-105 shadow-md'
                            : 'border-gray-300 hover:border-gray-500'
                        }`}
                        style={{ background: color.preview }}
                        title={color.label}
                      >
                        <span className={`text-xs font-medium ${color.preview.includes('gradient') ? 'text-white' : 'text-gray-700'}`}>
                          {color.label}
                        </span>
                      </button>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    Seçili: {navbarColorOptions.bg.find(c => c.value === formData.bg_color)?.label || formData.bg_color || 'Yok'}
                  </p>
                </div>

                {/* Hover Arka Plan Rengi */}
                <div>
                  <Label className="text-xs sm:text-sm">Hover Arka Plan Rengi</Label>
                  <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2 mt-2">
                    {navbarColorOptions.hoverBg.map((color) => (
                      <button
                        key={color.value}
                        type="button"
                        onClick={() => setFormData({ ...formData, hover_bg_color: color.value })}
                        className={`h-10 rounded-lg border-2 transition-all flex items-center justify-center ${
                          formData.hover_bg_color === color.value
                            ? 'border-gray-800 scale-105 shadow-md'
                            : 'border-gray-300 hover:border-gray-500'
                        }`}
                        style={{ backgroundColor: color.preview }}
                        title={color.label}
                      >
                        <span className="text-xs font-medium text-white drop-shadow-md">{color.label}</span>
                      </button>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    Seçili: {navbarColorOptions.hoverBg.find(c => c.value === formData.hover_bg_color)?.label || formData.hover_bg_color || 'Yok'}
                  </p>
                </div>

                {/* İkon Rengi */}
                <div>
                  <Label className="text-xs sm:text-sm">İkon Rengi (Alt menüler için)</Label>
                  <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2 mt-2">
                    {navbarColorOptions.text.map((color) => (
                      <button
                        key={color.value}
                        type="button"
                        onClick={() => setFormData({ ...formData, icon_color: color.value })}
                        className={`h-10 rounded-lg border-2 transition-all flex items-center justify-center ${
                          formData.icon_color === color.value
                            ? 'border-gray-800 scale-105 shadow-md'
                            : 'border-gray-300 hover:border-gray-500'
                        } ${color.preview === '#ffffff' || color.preview === '#f9fafb' ? 'ring-1 ring-gray-300' : ''}`}
                        style={{ backgroundColor: color.preview }}
                        title={color.label}
                      >
                        <span className={`text-xs font-medium ${color.preview === '#ffffff' || color.preview === '#f9fafb' ? 'text-gray-700' : 'text-white drop-shadow-md'}`}>
                          {color.label}
                        </span>
                      </button>
                    ))}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    Seçili: {navbarColorOptions.text.find(c => c.value === formData.icon_color)?.label || formData.icon_color || 'Metin ile aynı'}
                  </p>
                </div>

                {/* Manuel Giriş (İsteğe Bağlı) */}
                <details className="mt-4">
                  <summary className="cursor-pointer text-sm text-gray-600 hover:text-gray-900">Manuel renk gir (gelişmiş)</summary>
                  <div className="grid grid-cols-2 gap-4 mt-3">
                    <div>
                      <Label className="text-xs">Metin</Label>
                      <Input
                        value={formData.text_color || ''}
                        onChange={(e) => setFormData({ ...formData, text_color: e.target.value })}
                        placeholder="text-purple-600"
                        className="text-xs"
                      />
                    </div>
                    <div>
                      <Label className="text-xs">Hover Metin</Label>
                      <Input
                        value={formData.hover_color || ''}
                        onChange={(e) => setFormData({ ...formData, hover_color: e.target.value })}
                        placeholder="hover:text-purple-700"
                        className="text-xs"
                      />
                    </div>
                    <div>
                      <Label className="text-xs">Arka Plan</Label>
                      <Input
                        value={formData.bg_color || ''}
                        onChange={(e) => setFormData({ ...formData, bg_color: e.target.value })}
                        placeholder="bg-purple-50"
                        className="text-xs"
                      />
                    </div>
                    <div>
                      <Label className="text-xs">Hover Arka Plan</Label>
                      <Input
                        value={formData.hover_bg_color || ''}
                        onChange={(e) => setFormData({ ...formData, hover_bg_color: e.target.value })}
                        placeholder="hover:bg-purple-600"
                        className="text-xs"
                      />
                    </div>
                    <div>
                      <Label className="text-xs">İkon Rengi</Label>
                      <Input
                        value={formData.icon_color || ''}
                        onChange={(e) => setFormData({ ...formData, icon_color: e.target.value })}
                        placeholder="text-purple-600"
                        className="text-xs"
                      />
                    </div>
                  </div>
                </details>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                {/* Mega Menu checkbox'ı sadece ana menülerde göster */}
                {!formData.parent_id && (
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id="is_mega_menu"
                      checked={formData.is_mega_menu}
                      onChange={(e) => setFormData({ ...formData, is_mega_menu: e.target.checked })}
                    />
                    <Label htmlFor="is_mega_menu">Mega Menu</Label>
                  </div>
                )}
                <div className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    id="is_active"
                    checked={formData.is_active}
                    onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                  />
                  <Label htmlFor="is_active">Aktif</Label>
                </div>
                {/* Özel Stil checkbox'ı sadece ana menülerde göster */}
                {!formData.parent_id && (
                  <div className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id="is_special"
                      checked={formData.is_special}
                      onChange={(e) => setFormData({ ...formData, is_special: e.target.checked })}
                    />
                    <Label htmlFor="is_special">Özel Stil</Label>
                  </div>
                )}
                <div className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    id="is_promo_card"
                    checked={formData.is_promo_card}
                    onChange={(e) => setFormData({ ...formData, is_promo_card: e.target.checked })}
                  />
                  <Label htmlFor="is_promo_card">Promo Kart</Label>
                </div>
              </div>

              {/* Footer Sütun Ayarları */}
              {formData.type === 'footer' && (
                <div className="border border-gray-200 rounded-lg p-4 space-y-4">
                  <Label className="text-lg font-semibold">Footer Sütun Ayarları</Label>
                  <div>
                    <Label>Sütun</Label>
                    <select
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      value={formData.footer_column || ''}
                      onChange={(e) => setFormData({ ...formData, footer_column: e.target.value ? parseInt(e.target.value) : null })}
                    >
                      <option value="">Sütun Seçiniz</option>
                      <option value="2">2. Sütun (Hizmetlerimiz)</option>
                      <option value="3">3. Sütun (Kurumsal)</option>
                      <option value="4">4. Sütun (Bizi Takip Edin)</option>
                    </select>
                    <p className="text-xs text-gray-500 mt-1">
                      Bu menü footer'ın hangi sütununda gösterilecek
                    </p>
                  </div>
                </div>
              )}

              {/* Mega Menu Ayarları */}
              {(formData.is_mega_menu || formData.parent_id) && formData.type !== 'footer' && (
                <div className="border border-gray-200 rounded-lg p-4 space-y-4">
                  <Label className="text-lg font-semibold">Mega Menu Ayarları</Label>
                  
                  {/* Özel Sekme Yapısı (Sadece ana mega menu için) */}
                  {formData.is_mega_menu && !formData.parent_id && (
                    <div className="border-t pt-4 mt-4 space-y-3">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-2">
                          <input
                            type="checkbox"
                            id="has_custom_tabs"
                            checked={formData.has_custom_tabs || !!formData.hosting_tabs}
                            onChange={(e) => {
                              const hasTabs = e.target.checked;
                              // Eğer hosting_tabs boşsa, default yapı oluştur
                              let defaultTabs = formData.hosting_tabs;
                              if (hasTabs && (!defaultTabs || Object.keys(defaultTabs).length === 0)) {
                                defaultTabs = {
                                  tab1: { title: 'Yeni Sekme 1', order: 0, items: [] },
                                  tab2: { title: 'Yeni Sekme 2', order: 1, items: [] }
                                };
                              }
                              setFormData({ 
                                ...formData, 
                                has_custom_tabs: hasTabs,
                                hosting_tabs: hasTabs ? (defaultTabs || {}) : null
                              });
                            }}
                          />
                          <Label htmlFor="has_custom_tabs" className="cursor-pointer font-medium">
                            Özel Sekme Yapısı (Hosting gibi)
                          </Label>
                        </div>
                        {(formData.has_custom_tabs || formData.hosting_tabs) && (
                          <Button
                            type="button"
                            variant="outline"
                            size="sm"
                            onClick={async () => {
                              // Eğer menü henüz kaydedilmemişse, önce kaydet
                              if (!editingMenu) {
                                // Önce menüyü kaydet
                                try {
                                  const dataToSend = {
                                    ...formData,
                                    promo_data: formData.promo_data ? JSON.stringify(formData.promo_data) : null,
                                    hosting_tabs: formData.hosting_tabs ? JSON.stringify(formData.hosting_tabs) : null,
                                    is_mega_menu: formData.is_mega_menu ? 1 : 0,
                                    is_promo_card: formData.is_promo_card ? 1 : 0,
                                    is_list_format: formData.is_list_format ? 1 : 0,
                                    is_header: formData.is_header ? 1 : 0,
                                    is_special: formData.is_special ? 1 : 0,
                                    is_active: formData.is_active ? 1 : 0,
                                    has_tabs: (formData.has_custom_tabs || formData.hosting_tabs) ? 1 : 0,
                                    text_color: formData.text_color || null,
                                    hover_color: formData.hover_color || null,
                                    bg_color: formData.bg_color || null,
                                    hover_bg_color: formData.hover_bg_color || null,
                                    icon_color: formData.icon_color || null
                                  };
                                  
                                  const response = await adminApiFetch(`${apiBase}/backend/admin_api.php?action=createMenu`, {
                                    method: 'POST',
                                    body: JSON.stringify(dataToSend)
                                  });
                                  const result = await response.json();
                                  
                                  if (result.status === 'success' && result.data && result.data.id) {
                                    // Menü kaydedildi, ID'yi al
                                    const newMenuId = result.data.id;
                                    setEditingMenu(newMenuId);
                                    // FormData'yı güncelle
                                    setFormData({ ...formData, id: newMenuId });
                                    await fetchMenus();
                                    
                                    // Şimdi sekmeleri düzenle
                                    let tabs = formData.hosting_tabs || {};
                                    
                                    // Eğer hosting_tabs bir obje içinde tabs property'si varsa, onu kullan
                                    if (tabs.tabs && typeof tabs.tabs === 'object') {
                                      tabs = tabs.tabs;
                                    }
                                    
                                    // Eğer hala boşsa, default yapı oluştur
                                    if (!tabs || Object.keys(tabs).length === 0) {
                                      tabs = {
                                        tab1: { title: 'Yeni Sekme 1', order: 0, items: [] },
                                        tab2: { title: 'Yeni Sekme 2', order: 1, items: [] }
                                      };
                                    }
                                    
                                    const tabKeys = Object.keys(tabs);
                                    tabKeys.forEach((tabKey, index) => {
                                      if (tabs[tabKey] && (tabs[tabKey].order === undefined || tabs[tabKey].order === null)) {
                                        tabs[tabKey] = { ...tabs[tabKey], order: index };
                                      }
                                    });
                                    setEditingTabs(tabs);
                                    setEditingTabsMenuId(newMenuId);
                                    setShowTabsEditor(true);
                                  } else {
                                    alert('Menü kaydedilemedi. Lütfen önce menüyü kaydedin.');
                                  }
                                } catch (error) {
                                  console.error('Error saving menu:', error);
                                  alert('Menü kaydedilirken bir hata oluştu: ' + error.message);
                                }
                              } else {
                                // Menü zaten kaydedilmiş, direkt sekmeleri düzenle
                                let tabs = formData.hosting_tabs || {};
                                
                                // Eğer hosting_tabs bir obje içinde tabs property'si varsa, onu kullan
                                if (tabs.tabs && typeof tabs.tabs === 'object') {
                                  tabs = tabs.tabs;
                                }
                                
                                // Eğer hala boşsa, default yapı oluştur
                                if (!tabs || Object.keys(tabs).length === 0) {
                                  tabs = {
                                    tab1: { title: 'Yeni Sekme 1', order: 0, items: [] },
                                    tab2: { title: 'Yeni Sekme 2', order: 1, items: [] }
                                  };
                                }
                                
                                const tabKeys = Object.keys(tabs);
                                tabKeys.forEach((tabKey, index) => {
                                  if (tabs[tabKey] && (tabs[tabKey].order === undefined || tabs[tabKey].order === null)) {
                                    tabs[tabKey] = { ...tabs[tabKey], order: index };
                                  }
                                });
                                setEditingTabs(tabs);
                                setEditingTabsMenuId(editingMenu);
                                setShowTabsEditor(true);
                              }
                            }}
                          >
                            <Edit className="w-4 h-4 mr-2" />
                            Sekmeleri Düzenle
                          </Button>
                        )}
                      </div>
                      <p className="text-xs text-gray-500 ml-6">
                        {formData.has_custom_tabs 
                          ? 'Bu menü Hosting gibi sekme yapısına sahip olacak. Sekmeleri düzenlemek için butona tıklayın.'
                          : 'Bu menü normal mega menu olarak çalışacak. Sekme yapısı için işaretleyin.'}
                      </p>
                    </div>
                  )}
                  
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <Label>Kolon</Label>
                      <Input
                        type="number"
                        value={formData.mega_menu_column || ''}
                        onChange={(e) => setFormData({ ...formData, mega_menu_column: e.target.value ? parseInt(e.target.value) : null })}
                        placeholder="1, 2, 3..."
                      />
                    </div>
                    <div>
                      <Label>Bölüm</Label>
                      <select
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        value={formData.mega_menu_section || ''}
                        onChange={(e) => {
                          const section = e.target.value || null;
                          // Sağ taraf seçilmediğinde liste formatını sıfırla
                          if (section !== 'right') {
                            setFormData({ ...formData, mega_menu_section: section, is_list_format: false });
                          } else {
                            setFormData({ ...formData, mega_menu_section: section });
                          }
                        }}
                      >
                        <option value="">Sol Taraf (Varsayılan)</option>
                        <option value="right">Sağ Taraf</option>
                      </select>
                    </div>
                  </div>
                  
                  {/* Ana menü için sağ taraf formatı seçimi (tüm sağ taraf alt menülerine uygulanır) */}
                  {formData.is_mega_menu && !formData.parent_id && (
                    <div className="border-t pt-4 mt-4">
                      <Label className="text-base font-semibold mb-2 block">Sağ Taraf Formatı (Tüm Alt Menüler İçin)</Label>
                      <div className="space-y-3">
                        <div className="flex items-center space-x-2">
                          <input
                            type="radio"
                            id="right_format_list"
                            name="right_side_format"
                            checked={formData.is_list_format === true}
                            onChange={() => setFormData({ ...formData, is_list_format: true })}
                          />
                          <Label htmlFor="right_format_list" className="cursor-pointer font-medium">
                            Liste Formatı
                          </Label>
                        </div>
                        <div className="flex items-center space-x-2">
                          <input
                            type="radio"
                            id="right_format_card"
                            name="right_side_format"
                            checked={formData.is_list_format === false}
                            onChange={() => setFormData({ ...formData, is_list_format: false, promo_data: null })}
                          />
                          <Label htmlFor="right_format_card" className="cursor-pointer font-medium">
                            Kart Formatı
                          </Label>
                        </div>
                        
                        {formData.is_list_format ? (
                          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 space-y-1">
                            <p className="text-sm text-blue-800 font-medium">✓ Liste Formatı Seçildi</p>
                            <p className="text-xs text-blue-600">
                              Bu menünün tüm sağ taraf alt menüleri liste formatında gösterilecek (sadece başlık ve link).
                            </p>
                          </div>
                        ) : (
                          <div className="bg-orange-50 border border-orange-200 rounded-lg p-3 space-y-1">
                            <p className="text-sm text-orange-800 font-medium">✓ Kart Formatı Seçildi</p>
                            <p className="text-xs text-orange-600">
                              Bu menünün tüm sağ taraf alt menüleri kart formatında gösterilecek. Her alt menü için kart içeriği düzenlenebilir.
                            </p>
                          </div>
                        )}
                      </div>
                      
                      {/* Sağ Taraf Kart İçeriği (Ana menü için - sekme yapısı seçili olsa bile) */}
                      {!formData.is_list_format && (
                        <div className="border-t pt-4 mt-4">
                          <Label className="text-base font-semibold mb-3 block">Sağ Taraf Kart İçeriği</Label>
                          
                          {/* Üst Başlık */}
                          <div>
                            <Label>Üst Başlık (Opsiyonel)</Label>
                            <Input
                              value={formData.promo_data?.upperTitle || ''}
                              onChange={(e) => setFormData({
                                ...formData,
                                promo_data: { ...formData.promo_data, upperTitle: e.target.value || null }
                              })}
                              placeholder="Örn: Kolay Site"
                            />
                          </div>

                          {/* Ana Başlık */}
                          <div>
                            <Label>Ana Başlık *</Label>
                            <Input
                              value={formData.promo_data?.mainTitle || ''}
                              onChange={(e) => setFormData({
                                ...formData,
                                promo_data: { ...formData.promo_data, mainTitle: e.target.value || null }
                              })}
                              placeholder="Örn: Kolay Site Web Oluşturucu"
                            />
                          </div>

                          {/* Özellikler Listesi */}
                          <div>
                            <Label>Özellikler (Her satıra bir özellik)</Label>
                            <Textarea
                              value={formData.promo_data?.features ? formData.promo_data.features.join('\n') : ''}
                              onChange={(e) => {
                                const features = e.target.value.split('\n').filter(f => f.trim());
                                setFormData({
                                  ...formData,
                                  promo_data: { 
                                    ...formData.promo_data, 
                                    features: features.length > 0 ? features : null
                                  }
                                });
                              }}
                              placeholder="Yapay Zeka Destekli
Profesyonel Tasarımlar
Ücretsiz Alan Adı"
                              rows={4}
                            />
                          </div>

                          {/* Fiyatlar */}
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                            <div>
                              <Label>Eski Fiyat (Opsiyonel)</Label>
                              <Input
                                value={formData.promo_data?.priceOriginal || ''}
                                onChange={(e) => setFormData({
                                  ...formData,
                                  promo_data: { ...formData.promo_data, priceOriginal: e.target.value || null }
                                })}
                                placeholder="3,99$"
                              />
                            </div>
                            <div>
                              <Label>Yeni Fiyat (Opsiyonel)</Label>
                              <Input
                                value={formData.promo_data?.price || ''}
                                onChange={(e) => setFormData({
                                  ...formData,
                                  promo_data: { ...formData.promo_data, price: e.target.value || null }
                                })}
                                placeholder="0,69$/ay"
                              />
                            </div>
                          </div>

                          {/* Buton */}
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                            <div>
                              <Label>Buton Yazısı</Label>
                              <Input
                                value={formData.promo_data?.cta?.label || ''}
                                onChange={(e) => setFormData({
                                  ...formData,
                                  promo_data: { 
                                    ...formData.promo_data, 
                                    cta: { ...formData.promo_data?.cta, label: e.target.value || null } 
                                  }
                                })}
                                placeholder="İndirimli Satın Al"
                              />
                            </div>
                            <div>
                              <Label>Buton Linki</Label>
                              <Input
                                value={formData.promo_data?.cta?.path || formData.url || ''}
                                onChange={(e) => {
                                  const path = e.target.value;
                                  setFormData({
                                    ...formData,
                                    url: path,
                                    promo_data: { 
                                      ...formData.promo_data, 
                                      cta: { ...formData.promo_data?.cta, path: path || null } 
                                    }
                                  });
                                }}
                                placeholder="/kolay-site"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  
                  {/* Alt menü için sağ taraf ayarları */}
                  {formData.parent_id && formData.mega_menu_section === 'right' && (
                    <div className="border-t pt-4 mt-4 space-y-3">
                      {/* Liste formatında başlık/liste öğesi seçimi */}
                      {(() => {
                        const parentMenu = menus.find(m => m.id === formData.parent_id);
                        const parentIsListFormat = parentMenu ? (
                          parentMenu.is_list_format === true || 
                          parentMenu.is_list_format === 1 || 
                          parentMenu.is_list_format === '1'
                        ) : false;
                        
                        return parentIsListFormat ? (
                          <div className="space-y-2">
                            <Label className="text-sm font-semibold block">Sağ Taraf Öğe Tipi</Label>
                            <div className="flex items-center space-x-2">
                              <input
                                type="checkbox"
                                id="is_header"
                                checked={formData.is_header || false}
                                onChange={(e) => setFormData({ 
                                  ...formData, 
                                  is_header: e.target.checked,
                                  // Başlık ise url'yi temizle
                                  url: e.target.checked ? '' : formData.url
                                })}
                              />
                              <Label htmlFor="is_header" className="cursor-pointer font-medium">
                                Başlık (Siyah renk, link yok)
                              </Label>
                            </div>
                            {!formData.is_header && (
                              <p className="text-xs text-gray-500 ml-6">Liste öğesi olarak gösterilir (Gri renk, link var)</p>
                            )}
                            {formData.is_header && (
                              <p className="text-xs text-gray-500 ml-6">Başlık olarak gösterilir (Siyah renk, link yok)</p>
                            )}
                          </div>
                        ) : (
                          <div className="text-sm text-gray-600">
                            Not: Sağ taraf formatı ana menüden devralınır. Liste formatında başlık/liste öğesi seçebilirsiniz, kart formatında kart içeriğini düzenleyebilirsiniz.
                          </div>
                        );
                      })()}
                    </div>
                  )}
                </div>
              )}

              {/* Sağ Taraf Kart İçeriği (sadece alt menüde sağ taraf ve kart formatında) */}
              {formData.parent_id && formData.mega_menu_section === 'right' && (() => {
                const parentMenu = menus.find(m => m.id === formData.parent_id);
                const parentIsListFormat = parentMenu ? (
                  parentMenu.is_list_format === true || 
                  parentMenu.is_list_format === 1 || 
                  parentMenu.is_list_format === '1'
                ) : false;
                // Kart formatında ise kart içeriği göster
                return !parentIsListFormat;
              })() && (
                <div className="border border-gray-200 rounded-lg p-4 space-y-4">
                  <Label className="text-lg font-semibold">Kart İçeriği</Label>
                  
                  {/* Üst Başlık */}
                  <div>
                    <Label>Üst Başlık (Opsiyonel)</Label>
                    <Input
                      value={formData.promo_data?.upperTitle || ''}
                      onChange={(e) => setFormData({
                        ...formData,
                        promo_data: { ...formData.promo_data, upperTitle: e.target.value || null }
                      })}
                      placeholder="Örn: Kolay Site"
                    />
                  </div>

                  {/* Ana Başlık */}
                  <div>
                    <Label>Ana Başlık *</Label>
                    <Input
                      value={formData.promo_data?.mainTitle || ''}
                      onChange={(e) => setFormData({
                        ...formData,
                        promo_data: { ...formData.promo_data, mainTitle: e.target.value || null }
                      })}
                      placeholder="Örn: Kolay Site Web Oluşturucu"
                    />
                  </div>

                  {/* Özellikler Listesi */}
                  <div>
                    <Label>Özellikler (Her satıra bir özellik)</Label>
                    <Textarea
                      value={formData.promo_data?.features ? formData.promo_data.features.join('\n') : ''}
                      onChange={(e) => {
                        const features = e.target.value.split('\n').filter(f => f.trim());
                        setFormData({
                          ...formData,
                          promo_data: { 
                            ...formData.promo_data, 
                            features: features.length > 0 ? features : null
                          }
                        });
                      }}
                      placeholder="Yapay Zeka Destekli
Profesyonel Tasarımlar
Ücretsiz Alan Adı"
                      rows={4}
                    />
                  </div>

                  {/* Fiyatlar */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <Label>Eski Fiyat (Opsiyonel)</Label>
                      <Input
                        value={formData.promo_data?.priceOriginal || ''}
                        onChange={(e) => setFormData({
                          ...formData,
                          promo_data: { ...formData.promo_data, priceOriginal: e.target.value || null }
                        })}
                        placeholder="3,99$"
                      />
                    </div>
                    <div>
                      <Label>Yeni Fiyat (Opsiyonel)</Label>
                      <Input
                        value={formData.promo_data?.price || ''}
                        onChange={(e) => setFormData({
                          ...formData,
                          promo_data: { ...formData.promo_data, price: e.target.value || null }
                        })}
                        placeholder="0,69$/ay"
                      />
                    </div>
                  </div>

                  {/* Buton */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <Label>Buton Yazısı</Label>
                      <Input
                        value={formData.promo_data?.cta?.label || ''}
                        onChange={(e) => setFormData({
                          ...formData,
                          promo_data: { 
                            ...formData.promo_data, 
                            cta: { ...formData.promo_data?.cta, label: e.target.value || null } 
                          }
                        })}
                        placeholder="İndirimli Satın Al"
                      />
                    </div>
                    <div>
                      <Label>Buton Linki</Label>
                      <Input
                        value={formData.promo_data?.cta?.path || formData.url || ''}
                        onChange={(e) => {
                          const path = e.target.value;
                          setFormData({
                            ...formData,
                            url: path,
                            promo_data: { 
                              ...formData.promo_data, 
                              cta: { ...formData.promo_data?.cta, path: path || null } 
                            }
                          });
                        }}
                        placeholder="/kolay-site"
                      />
                    </div>
                  </div>

                  {/* Renkler */}
                  <div className="border-t pt-4 mt-4">
                    <Label className="text-base font-semibold mb-3 block">Kart Renkleri (Opsiyonel)</Label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                      <div>
                        <Label className="text-xs">Arka Plan Rengi</Label>
                        <Input
                          type="color"
                          value={formData.promo_data?.colors?.backgroundColor || '#f9fafb'}
                          onChange={(e) => setFormData({
                            ...formData,
                            promo_data: { 
                              ...formData.promo_data, 
                              colors: { 
                                ...formData.promo_data?.colors, 
                                backgroundColor: e.target.value 
                              } 
                            }
                          })}
                        />
                      </div>
                      <div>
                        <Label className="text-xs">Kenarlık Rengi</Label>
                        <Input
                          type="color"
                          value={formData.promo_data?.colors?.borderColor || '#e5e7eb'}
                          onChange={(e) => setFormData({
                            ...formData,
                            promo_data: { 
                              ...formData.promo_data, 
                              colors: { 
                                ...formData.promo_data?.colors, 
                                borderColor: e.target.value 
                              } 
                            }
                          })}
                        />
                      </div>
                      <div>
                        <Label className="text-xs">Başlık Rengi</Label>
                        <Input
                          type="color"
                          value={formData.promo_data?.colors?.headingColor || '#111827'}
                          onChange={(e) => setFormData({
                            ...formData,
                            promo_data: { 
                              ...formData.promo_data, 
                              colors: { 
                                ...formData.promo_data?.colors, 
                                headingColor: e.target.value 
                              } 
                            }
                          })}
                        />
                      </div>
                      <div>
                        <Label className="text-xs">Buton Arka Plan</Label>
                        <Input
                          type="color"
                          value={formData.promo_data?.colors?.buttonBg || '#9333ea'}
                          onChange={(e) => setFormData({
                            ...formData,
                            promo_data: { 
                              ...formData.promo_data, 
                              colors: { 
                                ...formData.promo_data?.colors, 
                                buttonBg: e.target.value 
                              } 
                            }
                          })}
                        />
                      </div>
                      <div>
                        <Label className="text-xs">Buton Hover</Label>
                        <Input
                          type="color"
                          value={formData.promo_data?.colors?.buttonHover || '#7e22ce'}
                          onChange={(e) => setFormData({
                            ...formData,
                            promo_data: { 
                              ...formData.promo_data, 
                              colors: { 
                                ...formData.promo_data?.colors, 
                                buttonHover: e.target.value 
                              } 
                            }
                          })}
                        />
                      </div>
                      <div>
                        <Label className="text-xs">Check İkon Rengi</Label>
                        <Input
                          type="color"
                          value={formData.promo_data?.colors?.checkColor || '#10b981'}
                          onChange={(e) => setFormData({
                            ...formData,
                            promo_data: { 
                              ...formData.promo_data, 
                              colors: { 
                                ...formData.promo_data?.colors, 
                                checkColor: e.target.value 
                              } 
                            }
                          })}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Promo Kart (sol taraf için) */}
              {formData.is_promo_card && formData.mega_menu_section !== 'right' && (
                <div className="border border-gray-200 rounded-lg p-4 space-y-4">
                  <Label className="text-lg font-semibold">Promo Kart Verileri</Label>
                  <div>
                    <Label>Başlık Satırları (JSON Array)</Label>
                    <Textarea
                      value={formData.promo_data?.titleLines ? JSON.stringify(formData.promo_data.titleLines) : ''}
                      onChange={(e) => {
                        try {
                          const titleLines = JSON.parse(e.target.value);
                          setFormData({
                            ...formData,
                            promo_data: { ...formData.promo_data, titleLines }
                          });
                        } catch (err) {
                          // Invalid JSON, ignore
                        }
                      }}
                      placeholder='["Satır 1", "Satır 2"]'
                      rows={2}
                    />
                  </div>
                  <div>
                    <Label>Özellikler (JSON Array)</Label>
                    <Textarea
                      value={formData.promo_data?.features ? JSON.stringify(formData.promo_data.features) : ''}
                      onChange={(e) => {
                        try {
                          const features = JSON.parse(e.target.value);
                          setFormData({
                            ...formData,
                            promo_data: { ...formData.promo_data, features }
                          });
                        } catch (err) {
                          // Invalid JSON, ignore
                        }
                      }}
                      placeholder='["Özellik 1", "Özellik 2"]'
                      rows={3}
                    />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div>
                      <Label>Eski Fiyat</Label>
                      <Input
                        value={formData.promo_data?.priceOriginal || ''}
                        onChange={(e) => setFormData({
                          ...formData,
                          promo_data: { ...formData.promo_data, priceOriginal: e.target.value }
                        })}
                        placeholder="3,99$"
                      />
                    </div>
                    <div>
                      <Label>Fiyat</Label>
                      <Input
                        value={formData.promo_data?.price || ''}
                        onChange={(e) => setFormData({
                          ...formData,
                          promo_data: { ...formData.promo_data, price: e.target.value }
                        })}
                        placeholder="0,69$/ay"
                      />
                    </div>
                  </div>
                  <div>
                    <Label>CTA Label</Label>
                    <Input
                      value={formData.promo_data?.cta?.label || ''}
                      onChange={(e) => setFormData({
                        ...formData,
                        promo_data: { ...formData.promo_data, cta: { ...formData.promo_data?.cta, label: e.target.value } }
                      })}
                      placeholder="İndirimli Satın Al"
                    />
                  </div>
                  <div>
                    <Label>CTA Path</Label>
                    <Input
                      value={formData.promo_data?.cta?.path || ''}
                      onChange={(e) => setFormData({
                        ...formData,
                        promo_data: { ...formData.promo_data, cta: { ...formData.promo_data?.cta, path: e.target.value } }
                      })}
                      placeholder="/kolay-site"
                    />
                  </div>
                </div>
              )}

              <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-2 pt-3 sm:pt-4">
                <Button variant="outline" onClick={() => setShowForm(false)} className="w-full sm:w-auto text-xs sm:text-sm">
                  İptal
                </Button>
                <Button onClick={handleSave} className="w-full sm:w-auto text-xs sm:text-sm">
                  <Save className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
                  Kaydet
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Hosting Tabs Editor Modal */}
      {showHostingTabsEditor && editingHostingTabs && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2 sm:p-4">
          <Card className="w-full max-w-5xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden flex flex-col">
            <CardHeader className="flex-shrink-0 p-3 sm:p-6 border-b">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
                <CardTitle className="text-base sm:text-lg">Hosting Mega Menu - Sekme Yönetimi</CardTitle>
                <Button variant="ghost" size="sm" onClick={() => setShowHostingTabsEditor(false)} className="self-end sm:self-auto">
                  <X className="w-4 h-4" />
                </Button>
              </div>
            </CardHeader>
            <CardContent className="flex-1 overflow-y-auto p-3 sm:p-6 space-y-6">
              {(() => {
                // Sekmeleri order'a göre sırala (order yoksa 0 kabul et)
                const sortedTabs = Object.keys(editingHostingTabs).map(tabKey => ({
                  key: tabKey,
                  tab: editingHostingTabs[tabKey],
                  order: editingHostingTabs[tabKey]?.order ?? 0
                })).sort((a, b) => a.order - b.order);
                
                return sortedTabs.map(({ key: tabKey, tab }, index) => {
                  const isFirst = index === 0;
                  const isLast = index === sortedTabs.length - 1;
                  const isExpanded = expandedHostingTabs.has(tabKey);
                  
                  return (
                    <div key={tabKey} className="border border-gray-200 rounded-lg overflow-hidden">
                      {/* Sekme Başlığı - Akordiyon Header */}
                      <div 
                        className="flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 cursor-pointer transition-colors"
                        onClick={() => {
                          const newExpanded = new Set(expandedHostingTabs);
                          if (isExpanded) {
                            newExpanded.delete(tabKey);
                          } else {
                            newExpanded.add(tabKey);
                          }
                          setExpandedHostingTabs(newExpanded);
                        }}
                      >
                        <div className="flex items-center gap-2">
                          <Button
                            variant="ghost"
                            size="sm"
                            className="h-6 w-6 p-0"
                            onClick={(e) => {
                              e.stopPropagation();
                              const newExpanded = new Set(expandedHostingTabs);
                              if (isExpanded) {
                                newExpanded.delete(tabKey);
                              } else {
                                newExpanded.add(tabKey);
                              }
                              setExpandedHostingTabs(newExpanded);
                            }}
                          >
                            {isExpanded ? (
                              <ChevronDown className="w-4 h-4" />
                            ) : (
                              <ChevronRight className="w-4 h-4" />
                            )}
                          </Button>
                          <h3 className="text-lg font-bold text-gray-900">{tab.title || tabKey}</h3>
                          <Badge variant="outline" className="text-xs">
                            Sıra: {tab.order ?? index}
                          </Badge>
                        </div>
                        <div className="flex items-center gap-2">
                          {/* Sıralama Butonları */}
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (isFirst) return;
                              const newTabs = { ...editingHostingTabs };
                              const prevTab = sortedTabs[index - 1];
                              const currentOrder = tab.order ?? index;
                              const prevOrder = prevTab.tab.order ?? (index - 1);
                              
                              // Sıraları değiştir
                              newTabs[tabKey] = { ...tab, order: prevOrder };
                              newTabs[prevTab.key] = { ...prevTab.tab, order: currentOrder };
                              setEditingHostingTabs(newTabs);
                            }}
                            disabled={isFirst}
                            className="h-8 w-8 p-0"
                            title="Yukarı taşı"
                          >
                            <ArrowUp className="w-4 h-4" />
                          </Button>
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (isLast) return;
                              const newTabs = { ...editingHostingTabs };
                              const nextTab = sortedTabs[index + 1];
                              const currentOrder = tab.order ?? index;
                              const nextOrder = nextTab.tab.order ?? (index + 1);
                              
                              // Sıraları değiştir
                              newTabs[tabKey] = { ...tab, order: nextOrder };
                              newTabs[nextTab.key] = { ...nextTab.tab, order: currentOrder };
                              setEditingHostingTabs(newTabs);
                            }}
                            disabled={isLast}
                            className="h-8 w-8 p-0"
                            title="Aşağı taşı"
                          >
                            <ArrowDown className="w-4 h-4" />
                          </Button>
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              const newTabs = { ...editingHostingTabs };
                              delete newTabs[tabKey];
                              setEditingHostingTabs(newTabs);
                            }}
                            className="text-red-600 hover:text-red-700"
                          >
                            <Trash2 className="w-4 h-4 mr-1" />
                            Sekmeyi Sil
                          </Button>
                        </div>
                      </div>
                    
                      {/* Sekme İçeriği - Akordiyon Content */}
                      {isExpanded && (
                        <div className="p-4 space-y-4">
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div>
                              <Label>Sekme Başlığı</Label>
                              <Input
                                value={tab.title || ''}
                                onChange={(e) => {
                                  const newTabs = { ...editingHostingTabs };
                                  newTabs[tabKey] = { ...tab, title: e.target.value };
                                  setEditingHostingTabs(newTabs);
                                }}
                                placeholder="Örn: Domain, Hosting, SSL, Sunucu"
                              />
                            </div>
                            <div>
                              <Label>Sıra (Order)</Label>
                              <Input
                                type="number"
                                value={tab.order ?? index}
                                onChange={(e) => {
                                  const newTabs = { ...editingHostingTabs };
                                  newTabs[tabKey] = { ...tab, order: parseInt(e.target.value) || 0 };
                                  setEditingHostingTabs(newTabs);
                                }}
                                placeholder="0"
                                className="text-xs"
                              />
                              <p className="text-xs text-gray-500 mt-1">Düşük sayı önce gösterilir</p>
                            </div>
                          </div>

                          <div>
                            <Label className="mb-2 block">Sekme Öğeleri</Label>
                            <div className="space-y-3">
                              <>
                              {(tab.items || []).map((item, idx) => {
                                const isFirstItem = idx === 0;
                                const isLastItem = idx === (tab.items || []).length - 1;
                                
                                return (
                          <div key={idx} className="border border-gray-200 rounded-lg p-3 space-y-2 bg-gray-50">
                            {/* Sıralama Butonları - Üst Kısım */}
                            <div className="flex items-center justify-between mb-2 pb-2 border-b border-gray-200">
                              <div className="flex items-center gap-1">
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={() => {
                                    if (isFirstItem) return;
                                    const newTabs = { ...editingHostingTabs };
                                    const items = [...newTabs[tabKey].items];
                                    [items[idx - 1], items[idx]] = [items[idx], items[idx - 1]];
                                    newTabs[tabKey].items = items;
                                    setEditingHostingTabs(newTabs);
                                  }}
                                  disabled={isFirstItem}
                                  className="h-7 w-7 p-0"
                                  title="Yukarı taşı"
                                >
                                  <ArrowUp className="w-3 h-3" />
                                </Button>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={() => {
                                    if (isLastItem) return;
                                    const newTabs = { ...editingHostingTabs };
                                    const items = [...newTabs[tabKey].items];
                                    [items[idx], items[idx + 1]] = [items[idx + 1], items[idx]];
                                    newTabs[tabKey].items = items;
                                    setEditingHostingTabs(newTabs);
                                  }}
                                  disabled={isLastItem}
                                  className="h-7 w-7 p-0"
                                  title="Aşağı taşı"
                                >
                                  <ArrowDown className="w-3 h-3" />
                                </Button>
                                <span className="text-xs text-gray-500 ml-1">Sıra: {idx + 1}</span>
                              </div>
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => {
                                  const newTabs = { ...editingHostingTabs };
                                  newTabs[tabKey].items.splice(idx, 1);
                                  setEditingHostingTabs(newTabs);
                                }}
                                className="text-red-600 hover:text-red-700 h-7"
                              >
                                <Trash2 className="w-3 h-3 mr-1" />
                                Sil
                              </Button>
                            </div>
                            
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                              <div>
                                <Label className="text-xs">Öğe Adı</Label>
                                <Input
                                  value={item.name || ''}
                                  onChange={(e) => {
                                    const newTabs = { ...editingHostingTabs };
                                    newTabs[tabKey].items[idx].name = e.target.value;
                                    setEditingHostingTabs(newTabs);
                                  }}
                                  placeholder="Örn: Sınırsız Web Hosting"
                                  className="text-xs"
                                />
                              </div>
                              <div>
                                <Label className="text-xs">URL</Label>
                                <Input
                                  value={item.path || ''}
                                  onChange={(e) => {
                                    const newTabs = { ...editingHostingTabs };
                                    newTabs[tabKey].items[idx].path = e.target.value;
                                    setEditingHostingTabs(newTabs);
                                  }}
                                  placeholder="/hosting"
                                  className="text-xs"
                                />
                              </div>
                            </div>
                            <div>
                              <Label className="text-xs">Açıklama</Label>
                              <Input
                                value={item.description || ''}
                                onChange={(e) => {
                                  const newTabs = { ...editingHostingTabs };
                                  newTabs[tabKey].items[idx].description = e.target.value;
                                  setEditingHostingTabs(newTabs);
                                }}
                                placeholder="0,69$'dan başlayan fiyatlarla"
                                className="text-xs"
                              />
                            </div>

                            {/* İkon ve Renk Ayarları - Sekme Öğesi İçin */}
                            <div className="border-t pt-3 mt-3">
                              <Label className="text-xs font-semibold mb-2 block">Öğe Görünüm Ayarları</Label>
                              
                              {/* İkon Seçimi */}
                              <div className="mb-3">
                                <Label className="text-xs mb-1 block">İkon</Label>
                                <div className="border border-gray-200 rounded-lg p-2 bg-white max-h-48 overflow-y-auto">
                                  <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-1.5">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        const newTabs = { ...editingHostingTabs };
                                        if (!newTabs[tabKey].items[idx]) newTabs[tabKey].items[idx] = {};
                                        newTabs[tabKey].items[idx].icon = null;
                                        setEditingHostingTabs(newTabs);
                                      }}
                                      className={`flex flex-col items-center justify-center p-2 rounded-lg border-2 transition-all ${
                                        !item.icon
                                          ? 'border-purple-600 bg-purple-50'
                                          : 'border-gray-200 hover:border-gray-300 bg-white'
                                      }`}
                                      title="İkon Kaldır"
                                    >
                                      <X className="w-4 h-4 text-gray-400" />
                                      <span className="text-[9px] mt-0.5 text-gray-500">Yok</span>
                                    </button>
                                    {iconOptions.map((iconOption) => {
                                      const IconComponent = iconOption.component;
                                      const isSelected = item.icon === iconOption.name;
                                      return (
                                        <button
                                          key={iconOption.name}
                                          type="button"
                                          onClick={() => {
                                            const newTabs = { ...editingHostingTabs };
                                            if (!newTabs[tabKey].items[idx]) newTabs[tabKey].items[idx] = {};
                                            newTabs[tabKey].items[idx].icon = iconOption.name;
                                            setEditingHostingTabs(newTabs);
                                          }}
                                          className={`flex flex-col items-center justify-center p-2 rounded-lg border-2 transition-all ${
                                            isSelected
                                              ? 'border-purple-600 bg-purple-50 scale-105'
                                              : 'border-gray-200 hover:border-gray-300 bg-white'
                                          }`}
                                          title={iconOption.name}
                                        >
                                          <IconComponent className={`w-4 h-4 ${isSelected ? 'text-purple-600' : 'text-gray-600'}`} />
                                          <span className={`text-[8px] mt-0.5 text-center leading-tight ${isSelected ? 'text-purple-700 font-medium' : 'text-gray-500'}`}>
                                            {iconOption.name.length > 8 ? iconOption.name.substring(0, 6) + '..' : iconOption.name}
                                          </span>
                                        </button>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>

                              {/* Renk Seçimleri */}
                              <div>
                                <Label className="text-xs mb-1 block">İkon Rengi</Label>
                                <div className="grid grid-cols-4 sm:grid-cols-5 gap-1.5 p-2 border border-gray-200 rounded-lg bg-white max-h-40 overflow-y-auto">
                                  {navbarColorOptions.text.map((color) => {
                                    const isSelected = item.icon_color === color.value;
                                    return (
                                      <button
                                        key={color.value}
                                        type="button"
                                        onClick={() => {
                                          const newTabs = JSON.parse(JSON.stringify(editingHostingTabs)); // Deep copy
                                          if (!newTabs[tabKey]) newTabs[tabKey] = { items: [] };
                                          if (!newTabs[tabKey].items) newTabs[tabKey].items = [];
                                          if (!newTabs[tabKey].items[idx]) newTabs[tabKey].items[idx] = {};
                                          newTabs[tabKey].items[idx].icon_color = color.value;
                                          setEditingHostingTabs(newTabs);
                                        }}
                                        className={`h-10 rounded-lg border-2 transition-all flex flex-col items-center justify-center ${
                                          isSelected
                                            ? 'border-purple-600 scale-105 shadow-md ring-2 ring-purple-300'
                                            : 'border-gray-300 hover:border-purple-400'
                                        }`}
                                        title={color.label}
                                      >
                                        <div 
                                          className="w-full h-5 rounded-t-lg" 
                                          style={{ backgroundColor: color.preview || '#374151' }}
                                        ></div>
                                        <span className={`text-[8px] px-0.5 mt-0.5 font-medium text-center leading-tight ${isSelected ? 'text-purple-700' : 'text-gray-600'}`}>
                                          {color.label}
                                        </span>
                                      </button>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                          );
                        })}
                            <Button
                                variant="outline"
                                size="sm"
                                onClick={() => {
                                  const newTabs = { ...editingHostingTabs };
                                  if (!newTabs[tabKey].items) newTabs[tabKey].items = [];
                                  newTabs[tabKey].items.push({ name: '', path: '', description: '' });
                                  setEditingHostingTabs(newTabs);
                                }}
                                className="w-full"
                              >
                                <Plus className="w-4 h-4 mr-2" />
                                Yeni Öğe Ekle
                              </Button>
                              </>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                });
              })()}
              
              <div className="border-t pt-4">
                <Button
                  variant="outline"
                  onClick={() => {
                    const newTabKey = `tab_${Date.now()}`;
                    const newTabs = { ...editingHostingTabs };
                    // Yeni sekme için maksimum order + 1
                    const maxOrder = Math.max(...Object.values(editingHostingTabs).map(t => t.order ?? 0), -1);
                    newTabs[newTabKey] = { title: 'Yeni Sekme', items: [], order: maxOrder + 1 };
                    setEditingHostingTabs(newTabs);
                  }}
                  className="w-full"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Yeni Sekme Ekle
                </Button>
              </div>

              {/* Sağ Taraf - Kart İçeriği */}
              <div className="border-t pt-6 mt-6">
                <div className="flex items-center justify-between mb-4">
                  <Label className="text-lg font-semibold">Kart İçeriği</Label>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => {
                      if (editingHostingRight) {
                        setEditingHostingRight(null);
                      } else {
                        setEditingHostingRight({
                          promo: {
                            titleLines: ['Jet Hızında', 'Başlangıç Hosting'],
                            features: ['1 Adet Web Sitesi', '10 GB SSD Disk Alanı', '500 GB Trafik', 'Ücretsiz Site Alan Adı'],
                            price: '0,69$/ay',
                            cta: { label: 'İndirimli Satın Al', path: '/hosting' }
                          }
                        });
                      }
                    }}
                  >
                    {editingHostingRight ? <X className="w-4 h-4 mr-2" /> : <Plus className="w-4 h-4 mr-2" />}
                    {editingHostingRight ? 'Kartı Kaldır' : 'Kart Ekle'}
                  </Button>
                </div>
                
                {editingHostingRight && editingHostingRight.promo && (
                  <div className="border border-gray-200 rounded-lg p-4 space-y-4 bg-gray-50">
                    {/* Üst Başlık */}
                    <div>
                      <Label>Üst Başlık (Opsiyonel)</Label>
                      <Input
                        value={editingHostingRight.promo.titleLines?.[0] || ''}
                        onChange={(e) => {
                          const titleLines = editingHostingRight.promo.titleLines || ['', ''];
                          titleLines[0] = e.target.value;
                          setEditingHostingRight({
                            ...editingHostingRight,
                            promo: { ...editingHostingRight.promo, titleLines }
                          });
                        }}
                        placeholder="Örn: Kolay Site"
                      />
                    </div>

                    {/* Ana Başlık */}
                    <div>
                      <Label>Ana Başlık *</Label>
                      <Input
                        value={editingHostingRight.promo.titleLines?.[1] || ''}
                        onChange={(e) => {
                          const titleLines = editingHostingRight.promo.titleLines || ['', ''];
                          titleLines[1] = e.target.value;
                          setEditingHostingRight({
                            ...editingHostingRight,
                            promo: { ...editingHostingRight.promo, titleLines }
                          });
                        }}
                        placeholder="Örn: Kolay Site Web Oluşturucu"
                      />
                    </div>

                    {/* Özellikler Listesi */}
                    <div>
                      <Label>Özellikler (Her satıra bir özellik)</Label>
                      <Textarea
                        value={(editingHostingRight.promo.features || []).join('\n')}
                        onChange={(e) => {
                          const features = e.target.value.split('\n').filter(f => f.trim());
                          setEditingHostingRight({
                            ...editingHostingRight,
                            promo: { 
                              ...editingHostingRight.promo, 
                              features: features.length > 0 ? features : []
                            }
                          });
                        }}
                        placeholder="Yapay Zeka Destekli
Profesyonel Tasarımlar
Ücretsiz Alan Adı"
                        rows={4}
                      />
                    </div>

                    {/* Fiyatlar */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                      <div>
                        <Label>Eski Fiyat (Opsiyonel)</Label>
                        <Input
                          value={editingHostingRight.promo.priceOriginal || ''}
                          onChange={(e) => setEditingHostingRight({
                            ...editingHostingRight,
                            promo: { ...editingHostingRight.promo, priceOriginal: e.target.value || null }
                          })}
                          placeholder="3,99$"
                        />
                      </div>
                      <div>
                        <Label>Yeni Fiyat (Opsiyonel)</Label>
                        <Input
                          value={editingHostingRight.promo.price || ''}
                          onChange={(e) => setEditingHostingRight({
                            ...editingHostingRight,
                            promo: { ...editingHostingRight.promo, price: e.target.value || null }
                          })}
                          placeholder="0,69$/ay"
                        />
                      </div>
                    </div>

                    {/* Buton */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                      <div>
                        <Label>Buton Yazısı</Label>
                        <Input
                          value={editingHostingRight.promo.cta?.label || ''}
                          onChange={(e) => setEditingHostingRight({
                            ...editingHostingRight,
                            promo: { 
                              ...editingHostingRight.promo, 
                              cta: { ...editingHostingRight.promo.cta, label: e.target.value || null } 
                            }
                          })}
                          placeholder="İndirimli Satın Al"
                        />
                      </div>
                      <div>
                        <Label>Buton Linki</Label>
                        <Input
                          value={editingHostingRight.promo.cta?.path || ''}
                          onChange={(e) => {
                            const path = e.target.value;
                            setEditingHostingRight({
                              ...editingHostingRight,
                              promo: { 
                                ...editingHostingRight.promo, 
                                cta: { ...editingHostingRight.promo.cta, path: path || null } 
                              }
                            });
                          }}
                          placeholder="/kolay-site"
                        />
                      </div>
                    </div>

                    {/* Renkler */}
                    <div className="border-t pt-4 mt-4">
                      <Label className="text-base font-semibold mb-3 block">Kart Renkleri (Opsiyonel)</Label>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                        <div>
                          <Label className="text-xs">Arka Plan Rengi</Label>
                          <Input
                            type="color"
                            value={editingHostingRight.promo.colors?.backgroundColor || '#f9fafb'}
                            onChange={(e) => setEditingHostingRight({
                              ...editingHostingRight,
                              promo: { 
                                ...editingHostingRight.promo, 
                                colors: { 
                                  ...editingHostingRight.promo.colors, 
                                  backgroundColor: e.target.value 
                                } 
                              }
                            })}
                          />
                        </div>
                        <div>
                          <Label className="text-xs">Kenarlık Rengi</Label>
                          <Input
                            type="color"
                            value={editingHostingRight.promo.colors?.borderColor || '#e5e7eb'}
                            onChange={(e) => setEditingHostingRight({
                              ...editingHostingRight,
                              promo: { 
                                ...editingHostingRight.promo, 
                                colors: { 
                                  ...editingHostingRight.promo.colors, 
                                  borderColor: e.target.value 
                                } 
                              }
                            })}
                          />
                        </div>
                        <div>
                          <Label className="text-xs">Başlık Rengi</Label>
                          <Input
                            type="color"
                            value={editingHostingRight.promo.colors?.headingColor || '#111827'}
                            onChange={(e) => setEditingHostingRight({
                              ...editingHostingRight,
                              promo: { 
                                ...editingHostingRight.promo, 
                                colors: { 
                                  ...editingHostingRight.promo.colors, 
                                  headingColor: e.target.value 
                                } 
                              }
                            })}
                          />
                        </div>
                        <div>
                          <Label className="text-xs">Buton Arka Plan</Label>
                          <Input
                            type="color"
                            value={editingHostingRight.promo.colors?.buttonBg || '#9333ea'}
                            onChange={(e) => setEditingHostingRight({
                              ...editingHostingRight,
                              promo: { 
                                ...editingHostingRight.promo, 
                                colors: { 
                                  ...editingHostingRight.promo.colors, 
                                  buttonBg: e.target.value 
                                } 
                              }
                            })}
                          />
                        </div>
                        <div>
                          <Label className="text-xs">Buton Hover</Label>
                          <Input
                            type="color"
                            value={editingHostingRight.promo.colors?.buttonHover || '#7e22ce'}
                            onChange={(e) => setEditingHostingRight({
                              ...editingHostingRight,
                              promo: { 
                                ...editingHostingRight.promo, 
                                colors: { 
                                  ...editingHostingRight.promo.colors, 
                                  buttonHover: e.target.value 
                                } 
                              }
                            })}
                          />
                        </div>
                        <div>
                          <Label className="text-xs">Check İkon Rengi</Label>
                          <Input
                            type="color"
                            value={editingHostingRight.promo.colors?.checkColor || '#10b981'}
                            onChange={(e) => setEditingHostingRight({
                              ...editingHostingRight,
                              promo: { 
                                ...editingHostingRight.promo, 
                                colors: { 
                                  ...editingHostingRight.promo.colors, 
                                  checkColor: e.target.value 
                                } 
                              }
                            })}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="flex flex-col sm:flex-row justify-end gap-2 pt-4 border-t">
                <Button variant="outline" onClick={() => setShowHostingTabsEditor(false)} className="w-full sm:w-auto">
                  İptal
                </Button>
                <Button
                  onClick={async () => {
                    try {
                      // Tabs ve right verisini birleştir
                      const hostingTabsData = {
                        ...editingHostingTabs
                      };
                      if (editingHostingRight) {
                        hostingTabsData.right = editingHostingRight;
                      }
                      
                      const response = await adminApiFetch(`${apiBase}/backend/admin_api.php?action=updateMenu`, {
                        method: 'POST',
                        body: JSON.stringify({
                          id: editingHostingMenuId,
                          hosting_tabs: JSON.stringify(hostingTabsData)
                        })
                      });
                      const result = await response.json();
                      if (result.status === 'success') {
                        await fetchMenus();
                        setShowHostingTabsEditor(false);
                        setEditingHostingRight(null);
                        alert('Hosting sekmeleri başarıyla kaydedildi!');
                      } else {
                        alert('Hata: ' + result.message);
                      }
                    } catch (error) {
                      alert('Kaydedilirken bir hata oluştu: ' + error.message);
                    }
                  }}
                  className="w-full sm:w-auto bg-green-600 hover:bg-green-700"
                >
                  <Save className="w-4 h-4 mr-2" />
                  Kaydet
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Generic Tabs Editor Modal */}
      {showTabsEditor && editingTabs && editingTabsMenuId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2 sm:p-4">
          <Card className="w-full max-w-5xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden flex flex-col">
            <CardHeader className="flex-shrink-0 p-3 sm:p-6 border-b">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
                <CardTitle className="text-base sm:text-lg">Sekme Yönetimi</CardTitle>
                <Button variant="ghost" size="sm" onClick={() => setShowTabsEditor(false)} className="self-end sm:self-auto">
                  <X className="w-4 h-4" />
                </Button>
              </div>
            </CardHeader>
            <CardContent className="flex-1 overflow-y-auto p-3 sm:p-6 space-y-6">
              {(() => {
                // Sekmeleri order'a göre sırala (order yoksa 0 kabul et)
                const sortedTabs = Object.keys(editingTabs).map(tabKey => ({
                  key: tabKey,
                  tab: editingTabs[tabKey],
                  order: editingTabs[tabKey]?.order ?? 0
                })).sort((a, b) => a.order - b.order);
                
                return sortedTabs.map(({ key: tabKey, tab }, index) => {
                  const isFirst = index === 0;
                  const isLast = index === sortedTabs.length - 1;
                  const isExpanded = expandedTabs.has(tabKey);
                  
                  return (
                    <div key={tabKey} className="border border-gray-200 rounded-lg overflow-hidden">
                      {/* Sekme Başlığı - Akordiyon Header */}
                      <div 
                        className="flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 cursor-pointer transition-colors"
                        onClick={() => {
                          const newExpanded = new Set(expandedTabs);
                          if (isExpanded) {
                            newExpanded.delete(tabKey);
                          } else {
                            newExpanded.add(tabKey);
                          }
                          setExpandedTabs(newExpanded);
                        }}
                      >
                        <div className="flex items-center gap-2">
                          <Button
                            variant="ghost"
                            size="sm"
                            className="h-6 w-6 p-0"
                            onClick={(e) => {
                              e.stopPropagation();
                              const newExpanded = new Set(expandedTabs);
                              if (isExpanded) {
                                newExpanded.delete(tabKey);
                              } else {
                                newExpanded.add(tabKey);
                              }
                              setExpandedTabs(newExpanded);
                            }}
                          >
                            {isExpanded ? (
                              <ChevronDown className="w-4 h-4" />
                            ) : (
                              <ChevronRight className="w-4 h-4" />
                            )}
                          </Button>
                          <h3 className="text-lg font-bold text-gray-900">{tab.title || tabKey}</h3>
                          <Badge variant="outline" className="text-xs">
                            Sıra: {tab.order ?? index}
                          </Badge>
                        </div>
                        <div className="flex items-center gap-2">
                          {/* Sıralama Butonları */}
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (isFirst) return;
                              const newTabs = { ...editingTabs };
                              const prevTab = sortedTabs[index - 1];
                              const currentOrder = tab.order ?? index;
                              const prevOrder = prevTab.tab.order ?? (index - 1);
                              
                              // Sıraları değiştir
                              newTabs[tabKey] = { ...tab, order: prevOrder };
                              newTabs[prevTab.key] = { ...prevTab.tab, order: currentOrder };
                              setEditingTabs(newTabs);
                            }}
                            disabled={isFirst}
                            className="h-8 w-8 p-0"
                            title="Yukarı taşı"
                          >
                            <ArrowUp className="w-4 h-4" />
                          </Button>
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (isLast) return;
                              const newTabs = { ...editingTabs };
                              const nextTab = sortedTabs[index + 1];
                              const currentOrder = tab.order ?? index;
                              const nextOrder = nextTab.tab.order ?? (index + 1);
                              
                              // Sıraları değiştir
                              newTabs[tabKey] = { ...tab, order: nextOrder };
                              newTabs[nextTab.key] = { ...nextTab.tab, order: currentOrder };
                              setEditingTabs(newTabs);
                            }}
                            disabled={isLast}
                            className="h-8 w-8 p-0"
                            title="Aşağı taşı"
                          >
                            <ArrowDown className="w-4 h-4" />
                          </Button>
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation();
                              const newTabs = { ...editingTabs };
                              delete newTabs[tabKey];
                              setEditingTabs(newTabs);
                            }}
                            className="text-red-600 hover:text-red-700"
                          >
                            <Trash2 className="w-4 h-4 mr-1" />
                            Sekmeyi Sil
                          </Button>
                        </div>
                      </div>
                    
                      {/* Sekme İçeriği - Akordiyon Content */}
                      {isExpanded && (
                        <div className="p-4 space-y-4">
                          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div>
                              <Label>Sekme Başlığı</Label>
                              <Input
                                value={tab.title || ''}
                                onChange={(e) => {
                                  const newTabs = { ...editingTabs };
                                  newTabs[tabKey] = { ...tab, title: e.target.value };
                                  setEditingTabs(newTabs);
                                }}
                                placeholder="Örn: Domain, Hosting, SSL, Sunucu"
                              />
                            </div>
                            <div>
                              <Label>Sıra (Order)</Label>
                              <Input
                                type="number"
                                value={tab.order ?? index}
                                onChange={(e) => {
                                  const newTabs = { ...editingTabs };
                                  newTabs[tabKey] = { ...tab, order: parseInt(e.target.value) || 0 };
                                  setEditingTabs(newTabs);
                                }}
                                placeholder="0"
                                className="text-xs"
                              />
                              <p className="text-xs text-gray-500 mt-1">Düşük sayı önce gösterilir</p>
                            </div>
                          </div>

                          <div>
                            <Label className="mb-2 block">Sekme Öğeleri</Label>
                            <div className="space-y-3">
                              <>
                              {(tab.items || []).map((item, idx) => {
                                const isFirstItem = idx === 0;
                                const isLastItem = idx === (tab.items || []).length - 1;
                                
                                return (
                            <div key={idx} className="border border-gray-200 rounded-lg p-3 space-y-2 bg-gray-50">
                              {/* Sıralama Butonları - Üst Kısım */}
                              <div className="flex items-center justify-between mb-2 pb-2 border-b border-gray-200">
                                <div className="flex items-center gap-1">
                                  <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => {
                                      if (isFirstItem) return;
                                      const newTabs = { ...editingTabs };
                                      const items = [...newTabs[tabKey].items];
                                      [items[idx - 1], items[idx]] = [items[idx], items[idx - 1]];
                                      newTabs[tabKey].items = items;
                                      setEditingTabs(newTabs);
                                    }}
                                    disabled={isFirstItem}
                                    className="h-7 w-7 p-0"
                                    title="Yukarı taşı"
                                  >
                                    <ArrowUp className="w-3 h-3" />
                                  </Button>
                                  <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => {
                                      if (isLastItem) return;
                                      const newTabs = { ...editingTabs };
                                      const items = [...newTabs[tabKey].items];
                                      [items[idx], items[idx + 1]] = [items[idx + 1], items[idx]];
                                      newTabs[tabKey].items = items;
                                      setEditingTabs(newTabs);
                                    }}
                                    disabled={isLastItem}
                                    className="h-7 w-7 p-0"
                                    title="Aşağı taşı"
                                  >
                                    <ArrowDown className="w-3 h-3" />
                                  </Button>
                                  <span className="text-xs text-gray-500 ml-1">Sıra: {idx + 1}</span>
                                </div>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  onClick={() => {
                                    const newTabs = { ...editingTabs };
                                    newTabs[tabKey].items.splice(idx, 1);
                                    setEditingTabs(newTabs);
                                  }}
                                  className="text-red-600 hover:text-red-700 h-7"
                                >
                                  <Trash2 className="w-3 h-3 mr-1" />
                                  Sil
                                </Button>
                              </div>
                              
                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                                <div>
                                  <Label className="text-xs">Öğe Adı</Label>
                                  <Input
                                    value={item.name || ''}
                                    onChange={(e) => {
                                      const newTabs = { ...editingTabs };
                                      newTabs[tabKey].items[idx].name = e.target.value;
                                      setEditingTabs(newTabs);
                                    }}
                                    placeholder="Örn: Sınırsız Web Hosting"
                                    className="text-xs"
                                  />
                                </div>
                                <div>
                                  <Label className="text-xs">URL</Label>
                                  <Input
                                    value={item.path || ''}
                                    onChange={(e) => {
                                      const newTabs = { ...editingTabs };
                                      newTabs[tabKey].items[idx].path = e.target.value;
                                      setEditingTabs(newTabs);
                                    }}
                                    placeholder="/hosting"
                                    className="text-xs"
                                  />
                                </div>
                              </div>
                              <div>
                                <Label className="text-xs">Açıklama</Label>
                                <Input
                                  value={item.description || ''}
                                  onChange={(e) => {
                                    const newTabs = { ...editingTabs };
                                    newTabs[tabKey].items[idx].description = e.target.value;
                                    setEditingTabs(newTabs);
                                  }}
                                  placeholder="0,69$'dan başlayan fiyatlarla"
                                  className="text-xs"
                                />
                              </div>

                              {/* İkon ve Renk Ayarları - Sekme Öğesi İçin */}
                              <div className="border-t pt-3 mt-3">
                                <Label className="text-xs font-semibold mb-2 block">Öğe Görünüm Ayarları</Label>
                                
                                {/* İkon Seçimi */}
                                <div className="mb-3">
                                  <Label className="text-xs mb-1 block">İkon</Label>
                                  <div className="border border-gray-200 rounded-lg p-2 bg-white max-h-48 overflow-y-auto">
                                    <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-1.5">
                                      <button
                                        type="button"
                                        onClick={() => {
                                          const newTabs = { ...editingTabs };
                                          if (!newTabs[tabKey].items[idx]) newTabs[tabKey].items[idx] = {};
                                          newTabs[tabKey].items[idx].icon = null;
                                          setEditingTabs(newTabs);
                                        }}
                                        className={`flex flex-col items-center justify-center p-2 rounded-lg border-2 transition-all ${
                                          !item.icon
                                            ? 'border-purple-600 bg-purple-50'
                                            : 'border-gray-200 hover:border-gray-300 bg-white'
                                        }`}
                                        title="İkon Kaldır"
                                      >
                                        <X className="w-4 h-4 text-gray-400" />
                                        <span className="text-[9px] mt-0.5 text-gray-500">Yok</span>
                                      </button>
                                      {iconOptions.map((iconOption) => {
                                        const IconComponent = iconOption.component;
                                        const isSelected = item.icon === iconOption.name;
                                        return (
                                          <button
                                            key={iconOption.name}
                                            type="button"
                                            onClick={() => {
                                              const newTabs = { ...editingTabs };
                                              if (!newTabs[tabKey].items[idx]) newTabs[tabKey].items[idx] = {};
                                              newTabs[tabKey].items[idx].icon = iconOption.name;
                                              setEditingTabs(newTabs);
                                            }}
                                            className={`flex flex-col items-center justify-center p-2 rounded-lg border-2 transition-all ${
                                              isSelected
                                                ? 'border-purple-600 bg-purple-50 scale-105'
                                                : 'border-gray-200 hover:border-gray-300 bg-white'
                                            }`}
                                            title={iconOption.name}
                                          >
                                            <IconComponent className={`w-4 h-4 ${isSelected ? 'text-purple-600' : 'text-gray-600'}`} />
                                            <span className={`text-[8px] mt-0.5 text-center leading-tight ${isSelected ? 'text-purple-700 font-medium' : 'text-gray-500'}`}>
                                              {iconOption.name.length > 8 ? iconOption.name.substring(0, 6) + '..' : iconOption.name}
                                            </span>
                                          </button>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>

                                {/* Renk Seçimleri */}
                                <div>
                                  <Label className="text-xs mb-1 block">İkon Rengi</Label>
                                  <div className="grid grid-cols-4 sm:grid-cols-5 gap-1.5 p-2 border border-gray-200 rounded-lg bg-white max-h-40 overflow-y-auto">
                                    {navbarColorOptions.text.map((color) => {
                                      const isSelected = item.icon_color === color.value;
                                      return (
                                        <button
                                          key={color.value}
                                          type="button"
                                          onClick={() => {
                                            const newTabs = JSON.parse(JSON.stringify(editingTabs)); // Deep copy
                                            if (!newTabs[tabKey]) newTabs[tabKey] = { items: [] };
                                            if (!newTabs[tabKey].items) newTabs[tabKey].items = [];
                                            if (!newTabs[tabKey].items[idx]) newTabs[tabKey].items[idx] = {};
                                            newTabs[tabKey].items[idx].icon_color = color.value;
                                            setEditingTabs(newTabs);
                                          }}
                                          className={`h-10 rounded-lg border-2 transition-all flex flex-col items-center justify-center ${
                                            isSelected
                                              ? 'border-purple-600 scale-105 shadow-md ring-2 ring-purple-300'
                                              : 'border-gray-300 hover:border-purple-400'
                                          }`}
                                          title={color.label}
                                        >
                                          <div 
                                            className="w-full h-5 rounded-t-lg" 
                                            style={{ backgroundColor: color.preview || '#374151' }}
                                          ></div>
                                          <span className={`text-[8px] px-0.5 mt-0.5 font-medium text-center leading-tight ${isSelected ? 'text-purple-700' : 'text-gray-600'}`}>
                                            {color.label}
                                          </span>
                                        </button>
                                      );
                                    })}
                                  </div>
                                </div>
                            </div>
                          </div>
                          );
                        })}
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => {
                                  const newTabs = { ...editingTabs };
                                  if (!newTabs[tabKey].items) newTabs[tabKey].items = [];
                                  newTabs[tabKey].items.push({ name: '', path: '', description: '' });
                                  setEditingTabs(newTabs);
                                }}
                                className="w-full"
                              >
                                <Plus className="w-4 h-4 mr-2" />
                                Yeni Öğe Ekle
                              </Button>
                              </>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                });
              })()}
              
              <div className="border-t pt-4">
                <Button
                  variant="outline"
                  onClick={() => {
                    const newTabKey = `tab_${Date.now()}`;
                    const newTabs = { ...editingTabs };
                    // Yeni sekme için maksimum order + 1
                    const maxOrder = Math.max(...Object.values(editingTabs).map(t => t.order ?? 0), -1);
                    newTabs[newTabKey] = { title: 'Yeni Sekme', items: [], order: maxOrder + 1 };
                    setEditingTabs(newTabs);
                  }}
                  className="w-full"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Yeni Sekme Ekle
                </Button>
              </div>

              <div className="flex flex-col sm:flex-row justify-end gap-2 pt-4 border-t">
                <Button variant="outline" onClick={() => setShowTabsEditor(false)} className="w-full sm:w-auto">
                  İptal
                </Button>
                <Button
                  onClick={async () => {
                    try {
                      // Mevcut menüden right verisini al (varsa)
                      const currentMenu = menus.find(m => m.id === editingTabsMenuId);
                      let rightData = null;
                      if (currentMenu && currentMenu.hosting_tabs) {
                        const existingTabs = typeof currentMenu.hosting_tabs === 'string' 
                          ? JSON.parse(currentMenu.hosting_tabs) 
                          : currentMenu.hosting_tabs;
                        if (existingTabs && existingTabs.right) {
                          rightData = existingTabs.right;
                        }
                      }
                      
                      // Tabs verisini kaydet (right verisini koru) - Deep copy kullan
                      const tabsData = {
                        tabs: JSON.parse(JSON.stringify(editingTabs)) // Deep copy to ensure all nested properties are included
                      };
                      if (rightData) {
                        tabsData.right = rightData;
                      }
                      
                      const response = await adminApiFetch(`${apiBase}/backend/admin_api.php?action=updateMenu`, {
                        method: 'POST',
                        body: JSON.stringify({
                          id: editingTabsMenuId,
                          hosting_tabs: JSON.stringify(tabsData)
                        })
                      });
                      const result = await response.json();
                      if (result.status === 'success') {
                        await fetchMenus();
                        // FormData'yı da güncelle
                        setFormData(prev => ({
                          ...prev,
                          hosting_tabs: tabsData
                        }));
                        setShowTabsEditor(false);
                        alert('Sekmeler başarıyla kaydedildi!');
                      } else {
                        alert('Hata: ' + result.message);
                      }
                    } catch (error) {
                      alert('Kaydedilirken bir hata oluştu: ' + error.message);
                    }
                  }}
                  className="w-full sm:w-auto bg-green-600 hover:bg-green-700"
                >
                  <Save className="w-4 h-4 mr-2" />
                  Kaydet
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Media Library Modal */}
      {showMediaLibrary && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
          <Card className="w-full max-w-4xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden flex flex-col">
            <CardHeader className="flex-shrink-0 p-3 sm:p-6">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0">
                <CardTitle className="text-base sm:text-lg">Medya Kütüphanesi</CardTitle>
                <Button variant="ghost" size="sm" onClick={() => setShowMediaLibrary(false)} className="self-end sm:self-auto">
                  <X className="w-4 h-4" />
                </Button>
              </div>
            </CardHeader>
            <CardContent className="flex-1 overflow-y-auto p-3 sm:p-6">
              {loadingMedia ? (
                <div className="text-center py-8 text-sm">Yükleniyor...</div>
              ) : (
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 sm:gap-4">
                  {mediaFiles.map((file, idx) => (
                    <button
                      key={idx}
                      onClick={() => handleSelectMedia(file)}
                      className="border-2 border-gray-200 hover:border-purple-500 rounded-lg p-2 transition-all hover:shadow-lg"
                    >
                      <img 
                        src={file.url} 
                        alt={file.name}
                        className="w-full h-32 object-cover rounded"
                      />
                      <p className="text-xs text-gray-600 mt-2 truncate">{file.name}</p>
                    </button>
                  ))}
                  {mediaFiles.length === 0 && (
                    <div className="col-span-full text-center py-8 text-gray-500">
                      Medya dosyası bulunamadı
                    </div>
                  )}
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
};

export default AdminMenus;

